{
  "names": [
    "940",
    "941",
    "943",
    "944",
    "945",
    "946",
    "947",
    "948",
    "949",
    "950",
    "952",
    "953",
    "954",
    "955",
    "956",
    "958",
    "959",
    "960",
    "961",
    "962",
    "963",
    "964",
    "966",
    "967",
    "968",
    "969",
    "970",
    "971",
    "972",
    "973",
    "974",
    "975",
    "978",
    "1233",
    "1234",
    "1235",
    "1236",
    "1237",
    "1238",
    "1242",
    "1243",
    "1246",
    "1253",
    "1254",
    "1258",
    "1259",
    "1260",
    "1264",
    "1265",
    "1273",
    "1275",
    "1276",
    "1277",
    "1278",
    "1279",
    "1280",
    "1281",
    "1282",
    "1283",
    "1284",
    "1285",
    "1286",
    "1287",
    "1288",
    "1289",
    "1290",
    "1291",
    "1292",
    "1293",
    "1294",
    "1295",
    "1296",
    "1297",
    "1298",
    "1308",
    "1309",
    "1310",
    "1374",
    "1415",
    "1439",
    "1441",
    "1443",
    "1486",
    "1487",
    "1489",
    "1490",
    "1491",
    "1494",
    "1495",
    "1497",
    "1499",
    "1500",
    "1501",
    "1502",
    "1503",
    "1504",
    "1505",
    "1506",
    "1507",
    "1508",
    "1510",
    "1511",
    "1512",
    "1513",
    "1514",
    "1515",
    "1516",
    "1517",
    "1518",
    "1519",
    "1521",
    "1524",
    "1526",
    "1527",
    "1530",
    "1531",
    "1532",
    "1533",
    "1534",
    "1535",
    "1536",
    "1537",
    "1539",
    "1540",
    "1541",
    "1542",
    "1543",
    "1544",
    "1545",
    "1546",
    "1547",
    "1548",
    "1549",
    "1550",
    "1551",
    "1552",
    "1553",
    "1554",
    "1555",
    "1556",
    "1557",
    "1558",
    "1561",
    "1562",
    "1563",
    "1564",
    "1572",
    "1573",
    "1574",
    "1576",
    "1577",
    "1581",
    "1601"
  ],
  "metadata": [
    {
      "id": 940,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 24,
      "location": "Beaufort/NC",
      "bbtype": "I",
      "wfreq": 2
    },
    {
      "id": 941,
      "ethnicity": "Caucasian/Midleastern",
      "gender": "F",
      "age": 34,
      "location": "Chicago/IL",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 943,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 49,
      "location": "Omaha/NE",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 944,
      "ethnicity": "European",
      "gender": "M",
      "age": 44,
      "location": "NewHaven/CT",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 945,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 48,
      "location": "Philidelphia/PA",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 946,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 42,
      "location": "Deerfield/MA",
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 947,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 49,
      "location": "ChapelHill/NC",
      "bbtype": "I",
      "wfreq": 6
    },
    {
      "id": 948,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 20,
      "location": "ChapelHill/NC",
      "bbtype": "I",
      "wfreq": null
    },
    {
      "id": 949,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 51,
      "location": "Durham/NC",
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 950,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 51,
      "location": "NewYork/NY",
      "bbtype": "I",
      "wfreq": 5
    },
    {
      "id": 952,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 51,
      "location": "Seattle/WA",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 953,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 38,
      "location": "Chicago/IL",
      "bbtype": "I",
      "wfreq": 2
    },
    {
      "id": 954,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 26,
      "location": "NewYork/NY",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 955,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 27,
      "location": "NewYork/NY",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 956,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 16,
      "location": "Jacksonville/NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 958,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 43,
      "location": "Wilmington/NC",
      "bbtype": "I",
      "wfreq": 5
    },
    {
      "id": 959,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 40,
      "location": "Carrboro/NC",
      "bbtype": "I",
      "wfreq": 5
    },
    {
      "id": 960,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 48,
      "location": "Lexington/NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 961,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 35,
      "location": "Edmonton,AB",
      "bbtype": "i",
      "wfreq": 4
    },
    {
      "id": 962,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 56,
      "location": "Washington,DC",
      "bbtype": "i",
      "wfreq": 1
    },
    {
      "id": 963,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 33,
      "location": "Ithaca/NY",
      "bbtype": "I",
      "wfreq": 3.5
    },
    {
      "id": 964,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 43,
      "location": "UK/London",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 966,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 56,
      "location": "Needham/MA",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 967,
      "ethnicity": "Caucasian/Jewish",
      "gender": "F",
      "age": 43,
      "location": "ChapelHill/NC",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 968,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 38,
      "location": "St.Louis/MI",
      "bbtype": "I",
      "wfreq": 6
    },
    {
      "id": 969,
      "ethnicity": "Caucasian/Asian",
      "gender": "F",
      "age": 31,
      "location": "ChevyChase/MD",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 970,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 42,
      "location": "SanDiego/CA",
      "bbtype": "i",
      "wfreq": 0
    },
    {
      "id": 971,
      "ethnicity": "Asian(South)",
      "gender": "M",
      "age": 36,
      "location": "SantaBarbara/CA",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 972,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 31,
      "location": "Charlotte/NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 973,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 4,
      "location": "Charlotte/NC",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 974,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 57,
      "location": "Raleigh/NC",
      "bbtype": "I",
      "wfreq": null
    },
    {
      "id": 975,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 60,
      "location": "NewCanaan/CT",
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 978,
      "ethnicity": "Hispanic",
      "gender": "F",
      "age": 21,
      "location": "Durham/NC",
      "bbtype": null,
      "wfreq": null
    },
    {
      "id": 1233,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 34,
      "location": null,
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1234,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": null,
      "location": null,
      "bbtype": "I",
      "wfreq": null
    },
    {
      "id": 1235,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 43,
      "location": null,
      "bbtype": null,
      "wfreq": 0
    },
    {
      "id": 1236,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 54,
      "location": null,
      "bbtype": null,
      "wfreq": 6
    },
    {
      "id": 1237,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 9,
      "location": "ChapelHill,NC",
      "bbtype": "i",
      "wfreq": 2
    },
    {
      "id": 1238,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 41,
      "location": "Raleigh,NC",
      "bbtype": "i",
      "wfreq": 0
    },
    {
      "id": 1242,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 44,
      "location": "Raleigh,NC",
      "bbtype": "i",
      "wfreq": 1
    },
    {
      "id": 1243,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 49,
      "location": "Raleigh,NC",
      "bbtype": "i",
      "wfreq": null
    },
    {
      "id": 1246,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 2,
      "location": "Atlanta,GA",
      "bbtype": null,
      "wfreq": 7
    },
    {
      "id": 1253,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 24,
      "location": "Voss,NC",
      "bbtype": "i",
      "wfreq": 5
    },
    {
      "id": 1254,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 1,
      "location": "Voss,NC",
      "bbtype": "o",
      "wfreq": 5
    },
    {
      "id": 1258,
      "ethnicity": "Caucasian",
      "gender": "f",
      "age": 31,
      "location": "Smithfield,NC",
      "bbtype": "i",
      "wfreq": 7
    },
    {
      "id": 1259,
      "ethnicity": "Caucasian",
      "gender": "m",
      "age": 33,
      "location": "Smithfield,NC",
      "bbtype": null,
      "wfreq": 7
    },
    {
      "id": 1260,
      "ethnicity": "Caucasian",
      "gender": "m",
      "age": 10,
      "location": "Smithfield,NC",
      "bbtype": null,
      "wfreq": 7
    },
    {
      "id": 1264,
      "ethnicity": "Caucasian",
      "gender": "m",
      "age": 46,
      "location": "Raleigh,NC",
      "bbtype": "i",
      "wfreq": 0
    },
    {
      "id": 1265,
      "ethnicity": "Caucasian",
      "gender": "f",
      "age": 10,
      "location": "Raleigh,NC",
      "bbtype": "i",
      "wfreq": 0
    },
    {
      "id": 1273,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 60,
      "location": null,
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 1275,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 18,
      "location": null,
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1276,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 34,
      "location": null,
      "bbtype": "O",
      "wfreq": 0
    },
    {
      "id": 1277,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 67,
      "location": null,
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1278,
      "ethnicity": null,
      "gender": "M",
      "age": 44,
      "location": null,
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1279,
      "ethnicity": "Black",
      "gender": "F",
      "age": 60,
      "location": null,
      "bbtype": "O",
      "wfreq": 9
    },
    {
      "id": 1280,
      "ethnicity": "PacificIslander",
      "gender": "F",
      "age": 30,
      "location": null,
      "bbtype": "I",
      "wfreq": null
    },
    {
      "id": 1281,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 55,
      "location": null,
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 1282,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 53,
      "location": null,
      "bbtype": "I",
      "wfreq": null
    },
    {
      "id": 1283,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 48,
      "location": null,
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1284,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 30,
      "location": null,
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1285,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 42,
      "location": null,
      "bbtype": "Both",
      "wfreq": null
    },
    {
      "id": 1286,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 38,
      "location": null,
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1287,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 46,
      "location": null,
      "bbtype": "I",
      "wfreq": null
    },
    {
      "id": 1288,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 52,
      "location": null,
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1289,
      "ethnicity": "Black",
      "gender": "F",
      "age": 38,
      "location": null,
      "bbtype": "I",
      "wfreq": null
    },
    {
      "id": 1290,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 53,
      "location": null,
      "bbtype": "I",
      "wfreq": 5
    },
    {
      "id": 1291,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 49,
      "location": null,
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1292,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 46,
      "location": null,
      "bbtype": "I",
      "wfreq": null
    },
    {
      "id": 1293,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 68,
      "location": null,
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 1294,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 46,
      "location": null,
      "bbtype": "I",
      "wfreq": null
    },
    {
      "id": 1295,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 48,
      "location": null,
      "bbtype": "Both",
      "wfreq": 7
    },
    {
      "id": 1296,
      "ethnicity": "Black",
      "gender": "f",
      "age": 10,
      "location": "Pinehurst,NC",
      "bbtype": "i",
      "wfreq": 4
    },
    {
      "id": 1297,
      "ethnicity": "Caucasion",
      "gender": "f",
      "age": 10,
      "location": "Pinehurst,NC",
      "bbtype": null,
      "wfreq": 5
    },
    {
      "id": 1298,
      "ethnicity": "White",
      "gender": "m",
      "age": 12,
      "location": "Pinehurst,NC",
      "bbtype": "i",
      "wfreq": 3
    },
    {
      "id": 1308,
      "ethnicity": "Black",
      "gender": "f",
      "age": 40,
      "location": "Durham,NC",
      "bbtype": null,
      "wfreq": 7
    },
    {
      "id": 1309,
      "ethnicity": "Black",
      "gender": "f",
      "age": 6,
      "location": "Durham,NC",
      "bbtype": null,
      "wfreq": 5
    },
    {
      "id": 1310,
      "ethnicity": "Black",
      "gender": "m",
      "age": 3,
      "location": "Durham,NC",
      "bbtype": null,
      "wfreq": 5
    },
    {
      "id": 1374,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 55,
      "location": "Cary,NC",
      "bbtype": "o",
      "wfreq": 7
    },
    {
      "id": 1415,
      "ethnicity": null,
      "gender": null,
      "age": null,
      "location": null,
      "bbtype": "Unknown",
      "wfreq": null
    },
    {
      "id": 1439,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": null,
      "location": "Sarasota,FL",
      "bbtype": null,
      "wfreq": null
    },
    {
      "id": 1441,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 36,
      "location": "Raleigh,NC",
      "bbtype": "I",
      "wfreq": 4
    },
    {
      "id": 1443,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 57,
      "location": "Raleigh,NC",
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 1486,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 33,
      "location": "Shrewsbury,UK",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1487,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 30,
      "location": "Shrewsbury,UK",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1489,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 28,
      "location": "WashingtonDC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1490,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 27,
      "location": "DurhamNC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1491,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 24,
      "location": "WashingtonDC",
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 1494,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 35,
      "location": "Boone,NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1495,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 57,
      "location": "Raleigh,NC",
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 1497,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 35,
      "location": "Raleigh,NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1499,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 33,
      "location": "Waynesville,NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1500,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 32,
      "location": "Raleigh,NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1501,
      "ethnicity": null,
      "gender": "M",
      "age": 38,
      "location": "FallsChurch,VA",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1502,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 27,
      "location": "Boone,NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1503,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 32,
      "location": "Raleigh,NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1504,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 27,
      "location": "Raleigh,NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1505,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 26,
      "location": "Durham,NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1506,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 21,
      "location": "Raleigh,NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1507,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 46,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1508,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 60,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1510,
      "ethnicity": "Black",
      "gender": "F",
      "age": 21,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 1511,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 46,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1512,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 55,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1513,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 15,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1514,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 3,
      "location": "NC",
      "bbtype": "o",
      "wfreq": 7
    },
    {
      "id": 1515,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 51,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 1516,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 57,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1517,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 27,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1518,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 25,
      "location": "GA",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1519,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 25,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1521,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 10,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1524,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 14,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 4
    },
    {
      "id": 1526,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 6,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1527,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 34,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1530,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 54,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 1531,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 39,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 2
    },
    {
      "id": 1532,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 38,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1533,
      "ethnicity": "Black",
      "gender": "M",
      "age": 37,
      "location": "NC",
      "bbtype": "o",
      "wfreq": 0
    },
    {
      "id": 1534,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 42,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1535,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 35,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1536,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 26,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1537,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 28,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1539,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 39,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1540,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 30,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1541,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 26,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1542,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 36,
      "location": "NC",
      "bbtype": "I",
      "wfreq": null
    },
    {
      "id": 1543,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 34,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 1544,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 33,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 1545,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 39,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1546,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 34,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 1547,
      "ethnicity": null,
      "gender": "M",
      "age": 38,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1548,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 6,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1549,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 37,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 1550,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 29,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1551,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 26,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1552,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 25,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 3
    },
    {
      "id": 1553,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 50,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1554,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 18,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1555,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 26,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1556,
      "ethnicity": "Hispanic",
      "gender": "M",
      "age": 34,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1557,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 26,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 2
    },
    {
      "id": 1558,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 26,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 1
    },
    {
      "id": 1561,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 31,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 2
    },
    {
      "id": 1562,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 39,
      "location": "MT",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1563,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 31,
      "location": "MT",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1564,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 36,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 5
    },
    {
      "id": 1572,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 33,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1573,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 53,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1574,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 30,
      "location": "OK",
      "bbtype": "I",
      "wfreq": 7
    },
    {
      "id": 1576,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 33,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1577,
      "ethnicity": "Caucasian",
      "gender": "M",
      "age": 26,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 0
    },
    {
      "id": 1581,
      "ethnicity": "Asian(American)",
      "gender": "F",
      "age": 22,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 2
    },
    {
      "id": 1601,
      "ethnicity": "Caucasian",
      "gender": "F",
      "age": 22,
      "location": "NC",
      "bbtype": "I",
      "wfreq": 2
    }
  ],
  "samples": [
    {
      "id": "940",
      "otu_ids": [
        1167,
        2859,
        482,
        2264,
        41,
        1189,
        352,
        189,
        2318,
        1977,
        3450,
        874,
        1959,
        2191,
        1950,
        2077,
        2275,
        944,
        2184,
        2244,
        2024,
        2419,
        2811,
        165,
        2782,
        2247,
        2011,
        2396,
        830,
        2964,
        1795,
        2722,
        307,
        2178,
        2908,
        1193,
        2167,
        1208,
        2039,
        1274,
        2739,
        2737,
        1314,
        1962,
        2186,
        2335,
        2936,
        907,
        833,
        2483,
        2475,
        2491,
        2291,
        159,
        2571,
        2350,
        2342,
        2546,
        725,
        170,
        1505,
        513,
        259,
        1169,
        258,
        1232,
        1497,
        1498,
        1503,
        412,
        2235,
        1960,
        1968,
        121,
        2065,
        340,
        2110,
        2188,
        357,
        342
      ],
      "sample_values": [
        163,
        126,
        113,
        78,
        71,
        51,
        50,
        47,
        40,
        40,
        37,
        36,
        30,
        28,
        25,
        23,
        22,
        19,
        19,
        14,
        13,
        13,
        13,
        12,
        12,
        11,
        11,
        11,
        10,
        10,
        10,
        8,
        7,
        7,
        7,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Gallicola",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Gallicola",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Firmicutes",
        "Bacteria",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria"
      ]
    },
    {
      "id": "941",
      "otu_ids": [
        2722,
        944,
        2419,
        2539,
        3450,
        1795,
        2389,
        1314,
        922,
        1167,
        2859,
        963,
        2964,
        2651,
        2308,
        482,
        874,
        2908,
        1870,
        2264,
        41,
        728,
        1188,
        352,
        2782,
        1926,
        1959,
        1200,
        1977,
        3312,
        261,
        296,
        2890,
        1929,
        555,
        2704,
        2688,
        710,
        189,
        2500,
        2461,
        854,
        939,
        1310
      ],
      "sample_values": [
        194,
        178,
        162,
        92,
        84,
        40,
        37,
        28,
        27,
        24,
        21,
        21,
        13,
        10,
        10,
        8,
        8,
        5,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Lachnospiraceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella"
      ]
    },
    {
      "id": "943",
      "otu_ids": [1795],
      "sample_values": [2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus"
      ]
    },
    {
      "id": "944",
      "otu_ids": [
        922,
        3555,
        943,
        1013,
        1795,
        944,
        3368,
        923,
        1770,
        3516,
        3120,
        3541,
        2308,
        3527,
        3312,
        41,
        1929,
        2651,
        2937,
        2722,
        728,
        2130,
        3440,
        3521,
        3523,
        3524,
        1035,
        970
      ],
      "sample_values": [
        278,
        33,
        19,
        18,
        11,
        8,
        7,
        5,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Enhydrobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Kocuria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Oceanospirillales;Oceanospirillaceae;Marinomonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Nocardioidaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermacoccaceae;Dermacoccus"
      ]
    },
    {
      "id": "945",
      "otu_ids": [
        944,
        1795,
        922,
        2419,
        2859,
        943,
        2722,
        1167,
        2651,
        1314,
        719,
        2190,
        2964,
        296,
        1169,
        2782,
        41,
        2011,
        728,
        2539,
        482,
        2571,
        2461,
        1286,
        3120,
        1200,
        909,
        2318,
        606,
        2389,
        3459,
        830,
        3450,
        2191,
        2275,
        1189,
        3379,
        3389,
        1929,
        930,
        2500,
        917,
        818,
        2551,
        1202,
        1380,
        3288,
        1728,
        2985,
        391,
        2524,
        2820,
        555,
        2244,
        2688,
        811,
        2647,
        2614,
        919,
        2855
      ],
      "sample_values": [
        274,
        141,
        129,
        110,
        40,
        37,
        35,
        32,
        26,
        20,
        17,
        15,
        15,
        15,
        15,
        14,
        14,
        12,
        10,
        10,
        9,
        8,
        8,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Janthinobacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingopyxis",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus"
      ]
    },
    {
      "id": "946",
      "otu_ids": [
        1167,
        2859,
        2011,
        41,
        296,
        909,
        2782,
        2722,
        2964,
        1314,
        1169,
        1286,
        2190,
        3459,
        2571,
        2419,
        2908,
        1200,
        2318,
        830,
        482,
        1189,
        3450,
        2985,
        2275,
        2539,
        2191,
        2396,
        2483,
        2264,
        391,
        841,
        1977,
        874,
        2079,
        944,
        1951,
        1188,
        2342,
        1197,
        1202,
        728,
        2086,
        491,
        833,
        2651,
        2308,
        1214,
        2244,
        854,
        2688,
        2479,
        2185,
        1218,
        2125,
        2058,
        1956,
        1289,
        1224,
        1094,
        2845,
        2724,
        2728,
        1141,
        2807,
        2820,
        2837,
        2873,
        2858,
        1174,
        814,
        2927,
        571,
        345,
        2987,
        97,
        1159,
        2233,
        2657,
        2654,
        2198,
        2341,
        1795,
        1487,
        2413,
        1292,
        2481,
        1251,
        2487,
        2536,
        2542,
        2544,
        2547,
        1220,
        2204,
        18
      ],
      "sample_values": [
        217,
        195,
        159,
        153,
        123,
        116,
        116,
        114,
        109,
        100,
        93,
        83,
        80,
        42,
        39,
        36,
        34,
        33,
        31,
        28,
        28,
        26,
        24,
        20,
        19,
        18,
        17,
        16,
        13,
        12,
        12,
        12,
        9,
        8,
        7,
        7,
        7,
        6,
        6,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Hallella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerosphaera",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerosphaera",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria"
      ]
    },
    {
      "id": "947",
      "otu_ids": [
        2419,
        2722,
        2859,
        944,
        2651,
        1795,
        3450,
        922,
        1167,
        2964,
        2539,
        728,
        2011,
        41,
        1314,
        1169,
        296,
        2190,
        2389,
        909,
        1286,
        2318,
        1453,
        2571,
        2908,
        2532,
        2769,
        2672,
        2557,
        2855,
        3459,
        2399,
        2483,
        2782,
        2845,
        2711,
        1602,
        2324,
        1200,
        830,
        2369,
        2985,
        482,
        1672,
        841,
        2858,
        2847,
        2846,
        3368,
        2820,
        2203,
        2762,
        2424,
        2704,
        2688,
        2675,
        2275,
        2638,
        2331,
        2560,
        2396,
        2526,
        2525,
        2500
      ],
      "sample_values": [
        412,
        236,
        200,
        135,
        115,
        102,
        46,
        45,
        27,
        24,
        23,
        19,
        15,
        13,
        11,
        10,
        9,
        9,
        9,
        7,
        6,
        6,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus"
      ]
    },
    {
      "id": "948",
      "otu_ids": [
        728,
        922,
        2722,
        943,
        2419,
        482,
        2859,
        1977,
        883,
        3643,
        1189,
        2011,
        2264,
        1167,
        2782,
        830,
        3036,
        3450,
        2396,
        2184,
        1314,
        41,
        944,
        2985,
        2539,
        1795,
        2308,
        936,
        2908,
        1169,
        982,
        963,
        833,
        2318,
        296,
        719,
        2754,
        2745,
        917,
        2046,
        165,
        3035,
        2190,
        314,
        595,
        2551,
        606,
        1208,
        2601,
        2666,
        2481,
        2461,
        938,
        2275,
        2167,
        2077,
        3439,
        623,
        874
      ],
      "sample_values": [
        225,
        185,
        64,
        57,
        55,
        50,
        47,
        29,
        23,
        20,
        20,
        19,
        18,
        18,
        18,
        15,
        14,
        13,
        12,
        12,
        10,
        10,
        9,
        9,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Parvimonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum"
      ]
    },
    {
      "id": "949",
      "otu_ids": [2419, 944, 1795],
      "sample_values": [8, 4, 3],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus"
      ]
    },
    {
      "id": "950",
      "otu_ids": [
        1795,
        922,
        944,
        3360,
        1929,
        830,
        1724,
        1728,
        1770,
        3541,
        3036,
        3402,
        2419,
        3581,
        3196,
        3396,
        2859,
        595,
        3398,
        1682,
        3523,
        3527,
        1453,
        1706,
        3356,
        1600,
        1300,
        3043,
        3184,
        3124,
        1794,
        3123,
        3093,
        659,
        1788,
        1784,
        1768,
        1760,
        1739,
        1593,
        1584,
        1108,
        1016,
        3585
      ],
      "sample_values": [
        427,
        123,
        14,
        13,
        13,
        11,
        10,
        7,
        7,
        7,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Rhodocyclales;Rhodocyclaceae;Zoogloea",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bosea",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Rhodocyclales;Rhodocyclaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Leptotrichia",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Caulobacter",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Caulobacter",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Bacillaceae;Tumebacillus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Bacteroidetes",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Rothia",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae"
      ]
    },
    {
      "id": "952",
      "otu_ids": [
        922,
        943,
        2539,
        728,
        982,
        989,
        883,
        2722,
        2419,
        939,
        719,
        2461,
        818,
        606,
        2389,
        1870,
        944,
        2011,
        2859,
        917,
        830,
        2184,
        2167,
        2264,
        482,
        2308,
        789,
        2266,
        737,
        2754,
        2077,
        1314,
        963,
        3368,
        2782,
        2949,
        352,
        1898,
        2704,
        2394,
        2219,
        1040,
        763,
        3507
      ],
      "sample_values": [
        182,
        79,
        52,
        43,
        38,
        36,
        34,
        32,
        32,
        30,
        28,
        23,
        14,
        13,
        13,
        11,
        11,
        10,
        8,
        7,
        7,
        6,
        6,
        6,
        6,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Fastidiosipila",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Carnobacteriaceae;Granulicatella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Nocardioidaceae;Nocardioides",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae"
      ]
    },
    {
      "id": "953",
      "otu_ids": [
        922,
        1795,
        944,
        943,
        963,
        2419,
        818,
        719,
        2389,
        763,
        1013,
        1602,
        1728,
        606,
        1724,
        1600,
        938,
        933,
        2539
      ],
      "sample_values": [
        302,
        246,
        54,
        23,
        14,
        12,
        7,
        6,
        5,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Kocuria",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus"
      ]
    },
    {
      "id": "954",
      "otu_ids": [
        944,
        1795,
        922,
        3120,
        3312,
        930,
        1602,
        919,
        1724,
        811,
        710,
        631,
        555,
        3288,
        1728,
        1639,
        659,
        3119,
        1840,
        672,
        1685,
        719,
        1634,
        1618,
        733,
        1525,
        927,
        917,
        899,
        818,
        767,
        1600
      ],
      "sample_values": [
        335,
        275,
        265,
        10,
        8,
        6,
        6,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingopyxis",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli"
      ]
    },
    {
      "id": "955",
      "otu_ids": [
        922,
        2419,
        2722,
        2859,
        944,
        943,
        2651,
        1795,
        719,
        1167,
        2539,
        3312,
        41,
        1286,
        2964,
        2190,
        296,
        818,
        3450,
        2275,
        3288,
        3120,
        606,
        1314,
        2908,
        3378,
        482,
        2985,
        728,
        2782,
        3541,
        833,
        2191,
        2011,
        963,
        2666,
        909,
        917,
        2338,
        3119,
        1952,
        1453,
        3459,
        1200
      ],
      "sample_values": [
        137,
        91,
        61,
        58,
        49,
        38,
        31,
        26,
        17,
        17,
        14,
        13,
        12,
        12,
        10,
        9,
        7,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingopyxis",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Herminiimonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas"
      ]
    },
    {
      "id": "956",
      "otu_ids": [
        1795,
        2419,
        1167,
        944,
        922,
        2308,
        2859,
        482,
        728,
        41,
        352,
        3476,
        1977,
        2264,
        1189,
        1959,
        874,
        2908,
        2782,
        189,
        2011,
        2722,
        165,
        2077,
        2275,
        943,
        2247,
        833,
        1950,
        2184,
        3450,
        2191,
        830,
        1728,
        2190,
        2318,
        2571,
        2737,
        2046,
        2539,
        2396,
        2123,
        2039,
        1314,
        909,
        3551
      ],
      "sample_values": [
        179,
        45,
        41,
        34,
        33,
        32,
        28,
        27,
        24,
        19,
        19,
        18,
        14,
        13,
        12,
        10,
        9,
        8,
        8,
        7,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Gallicola",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter"
      ]
    },
    {
      "id": "958",
      "otu_ids": [
        922,
        2308,
        1795,
        943,
        2419,
        2389,
        2539,
        659,
        763,
        3541,
        775,
        2339,
        3476,
        1602,
        932,
        2445,
        2604,
        2300,
        1615,
        2455,
        2461,
        2535,
        2621,
        2627,
        2634,
        223
      ],
      "sample_values": [
        637,
        414,
        122,
        64,
        46,
        17,
        11,
        9,
        7,
        6,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria"
      ]
    },
    {
      "id": "959",
      "otu_ids": [
        1795,
        922,
        943,
        936,
        924,
        3544,
        659,
        763,
        1054,
        1681,
        1792,
        1794,
        3549
      ],
      "sample_values": [150, 147, 16, 10, 6, 3, 2, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Bifidobacteriales;Bifidobacteriaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter"
      ]
    },
    {
      "id": "960",
      "otu_ids": [
        922,
        944,
        1795,
        2419,
        943,
        2722,
        3541,
        1929,
        3581,
        976,
        1014,
        3643,
        3381,
        2859,
        3544,
        3389,
        728,
        2782,
        2461,
        1739,
        1453,
        945,
        2396
      ],
      "sample_values": [
        40,
        34,
        32,
        27,
        6,
        6,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Intrasporangiaceae;Janibacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Naxibacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Bacillaceae;Tumebacillus",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus"
      ]
    },
    {
      "id": "961",
      "otu_ids": [
        1795,
        2722,
        909,
        2859,
        1314,
        1724,
        944,
        2539,
        1728,
        830,
        1600,
        2419,
        1167,
        3541,
        1788,
        1055,
        922
      ],
      "sample_values": [
        430,
        33,
        20,
        19,
        11,
        9,
        9,
        8,
        6,
        6,
        4,
        4,
        4,
        3,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Bifidobacteriales;Bifidobacteriaceae;Alloscardovia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium"
      ]
    },
    {
      "id": "962",
      "otu_ids": [
        3312,
        3288,
        3120,
        3284,
        1795,
        3119,
        1911,
        3541,
        3352,
        3378,
        3581,
        1921,
        3196,
        3320,
        883,
        3328,
        3371,
        3184,
        3485,
        3111,
        3593,
        943,
        3227,
        3372,
        3389,
        1293
      ],
      "sample_values": [
        180,
        97,
        72,
        45,
        24,
        19,
        17,
        14,
        12,
        11,
        6,
        6,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingopyxis",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Lactococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Herminiimonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bosea",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Variovorax",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodobacterales;Rhodobacteraceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella"
      ]
    },
    {
      "id": "963",
      "otu_ids": [
        728,
        2419,
        1870,
        2539,
        2859,
        922,
        944,
        1167,
        3312,
        2244,
        3288,
        482,
        3643,
        3120,
        41,
        943,
        2264,
        1795,
        1169,
        3541,
        165,
        3407,
        2811,
        2722,
        2964,
        2782,
        1950,
        3615,
        719,
        3378,
        830,
        2908,
        3284,
        1977,
        854,
        2275,
        2190,
        3450,
        2011,
        2308,
        833,
        391,
        841,
        3406,
        3404,
        939,
        314,
        352,
        3119,
        121,
        1314,
        1208,
        978,
        923,
        2651
      ],
      "sample_values": [
        96,
        70,
        47,
        43,
        40,
        40,
        39,
        26,
        25,
        22,
        20,
        19,
        18,
        17,
        16,
        14,
        13,
        13,
        11,
        10,
        10,
        9,
        9,
        8,
        7,
        7,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingopyxis",
        "Bacteria",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Desulfovibrionales;Desulfovibrionaceae;Desulfovibrio",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Cloacibacillus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Herminiimonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Desulfovibrionales",
        "Bacteria;Proteobacteria;Deltaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Intrasporangiaceae;Phycicoccus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus"
      ]
    },
    {
      "id": "964",
      "otu_ids": [
        728,
        944,
        2419,
        352,
        482,
        2859,
        1795,
        1167,
        2184,
        3352,
        3184,
        922,
        3363,
        830,
        41,
        2571,
        189,
        2011,
        2754,
        1361,
        1962,
        1959,
        1929,
        954,
        894,
        874,
        833,
        3368,
        981,
        2893,
        883
      ],
      "sample_values": [
        24,
        17,
        15,
        13,
        12,
        11,
        11,
        9,
        8,
        8,
        7,
        6,
        5,
        5,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae;Cloacibacterium",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Brachybacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Kineosporiaceae;Quadrisphaera",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Lachnospiraceae;Dorea",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium"
      ]
    },
    {
      "id": "966",
      "otu_ids": [
        943,
        922,
        1453,
        1795,
        1929,
        944,
        928,
        1895,
        3476,
        909,
        954,
        1870,
        1876,
        728,
        3555,
        923,
        3541,
        3581,
        2651,
        1014,
        2722,
        2419,
        3030,
        1239,
        2782,
        3396,
        541,
        3591,
        1926,
        2266,
        3402,
        3482,
        830,
        3040,
        3274,
        3372,
        3397,
        2,
        3612,
        187,
        1762,
        939,
        976,
        3523,
        3544,
        3036,
        3029,
        1456,
        419,
        1919,
        2308,
        659,
        3574,
        719,
        797,
        3527,
        3611,
        883,
        885,
        2011,
        945,
        963,
        2244,
        1038,
        3134,
        3045,
        1109,
        1293,
        2891,
        1917,
        2318,
        3352
      ],
      "sample_values": [
        268,
        171,
        43,
        41,
        30,
        20,
        19,
        18,
        17,
        13,
        12,
        12,
        11,
        10,
        10,
        9,
        9,
        8,
        8,
        8,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Carnobacteriaceae;Dolosigranulum",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Brachybacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Abiotrophia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Enhydrobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Acidobacteria;Acidobacteria_Gp6;Gp6",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Betaproteobacteria;Rhodocyclales;Rhodocyclaceae;Zoogloea",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Leptotrichia",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Nitrosomonadales;Nitrosomonadaceae;Nitrosomonas",
        "Archaea;Euryarchaeota;Halobacteria;Halobacteriales;Halobacteriaceae;Halococcus",
        "Bacteria;Spirochaetes;Spirochaetes;Spirochaetales;Spirochaetaceae;Treponema",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Intrasporangiaceae;Janibacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Spirochaetes;Spirochaetes;Spirochaetales;Spirochaetaceae;Treponema",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Nocardioidaceae;Marmoricola",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Leptotrichia",
        "Bacteria;Bacteroidetes",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Lachnospiraceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia"
      ]
    },
    {
      "id": "967",
      "otu_ids": [
        2539,
        2722,
        3450,
        2419,
        939,
        2964,
        963,
        944,
        728,
        2404,
        952,
        2572,
        134,
        1795,
        959,
        950,
        1870,
        2234,
        965,
        2688,
        2736,
        820
      ],
      "sample_values": [
        239,
        72,
        44,
        38,
        29,
        23,
        18,
        13,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales"
      ]
    },
    {
      "id": "968",
      "otu_ids": [
        922,
        944,
        2419,
        2461,
        1795,
        1870,
        2389,
        2722,
        2571,
        2394,
        2551,
        2859,
        963,
        2539,
        763,
        2011,
        1000,
        2318,
        2308,
        2445,
        2964,
        1200,
        631,
        943,
        919,
        930,
        2601,
        728,
        2524,
        2500,
        2425,
        945,
        2190,
        940,
        555,
        908,
        883,
        1167,
        1189,
        2602,
        2614,
        2648,
        710,
        343
      ],
      "sample_values": [
        398,
        242,
        199,
        35,
        29,
        28,
        25,
        20,
        14,
        14,
        13,
        12,
        10,
        10,
        8,
        7,
        6,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae;Zimmermannella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria"
      ]
    },
    {
      "id": "969",
      "otu_ids": [944, 1795, 919, 2722],
      "sample_values": [90, 28, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia"
      ]
    },
    {
      "id": "970",
      "otu_ids": [1795, 3360, 3544, 1408, 1724, 3288, 3541],
      "sample_values": [39, 3, 3, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Cytophagaceae;Adhaeribacter",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingopyxis",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter"
      ]
    },
    {
      "id": "971",
      "otu_ids": [
        922,
        943,
        2419,
        2389,
        2539,
        2461,
        944,
        1795,
        482,
        2859,
        3541,
        1839,
        2308,
        1870,
        728,
        818,
        719,
        2648,
        1167,
        2571,
        939,
        2011,
        2985,
        3396,
        917,
        2413,
        606,
        3177,
        3224,
        3450,
        659,
        3581
      ],
      "sample_values": [
        281,
        88,
        66,
        58,
        36,
        35,
        17,
        12,
        10,
        10,
        7,
        7,
        7,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Aurantimonadaceae;Aurantimonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodobacterales;Rhodobacteraceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas"
      ]
    },
    {
      "id": "972",
      "otu_ids": [
        922,
        1795,
        2859,
        2419,
        2539,
        728,
        944,
        2722,
        1870,
        2396,
        1167,
        2308,
        352,
        2264,
        1189,
        909,
        2389,
        2318,
        3450,
        1839,
        3643,
        830,
        841,
        874,
        482,
        41,
        2024,
        854,
        943,
        2571,
        1314,
        3541,
        963,
        2188,
        1335,
        2077,
        936,
        1021,
        2191,
        2184,
        1977,
        939,
        165,
        924,
        1959,
        2908,
        3570,
        1200,
        3494,
        3476,
        296,
        3368,
        1691,
        1428,
        763,
        2088,
        2461,
        883,
        2011,
        1162
      ],
      "sample_values": [
        74,
        60,
        50,
        44,
        37,
        35,
        25,
        24,
        21,
        16,
        16,
        14,
        13,
        12,
        11,
        11,
        10,
        10,
        10,
        9,
        9,
        9,
        9,
        8,
        8,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Nocardiaceae;Gordonia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Sphingobacteriaceae;Sphingobacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas"
      ]
    },
    {
      "id": "973",
      "otu_ids": [
        2859,
        944,
        2419,
        1795,
        1167,
        922,
        2011,
        41,
        2782,
        482,
        2964,
        1839,
        2722,
        3450,
        3030,
        2985,
        1870,
        2275,
        1189,
        3476,
        2318,
        352,
        1724,
        1314,
        1291,
        3360,
        909
      ],
      "sample_values": [
        24,
        21,
        19,
        15,
        10,
        8,
        8,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae"
      ]
    },
    {
      "id": "974",
      "otu_ids": [
        1870,
        2539,
        2389,
        2419,
        922,
        728,
        2859,
        2244,
        909,
        944,
        2558,
        2275,
        2461,
        2314,
        2782,
        482,
        2722,
        943,
        2651,
        1882,
        2308,
        2307,
        2404,
        883,
        2569,
        2648,
        2571,
        2908,
        2438,
        2378,
        907,
        2219,
        1853,
        841,
        1960,
        2742,
        2524,
        2602,
        2445,
        2372,
        719,
        972,
        939,
        2431,
        2394,
        2567,
        2647,
        113,
        814,
        2327,
        2645,
        2901,
        2769,
        2800,
        2620,
        2855,
        2827,
        2949,
        2710,
        29,
        2562,
        2551,
        134,
        283,
        658,
        737,
        963,
        1361,
        1795,
        1850,
        1868,
        1929,
        1971,
        2295,
        2297,
        2364,
        2390,
        2413,
        2494,
        2500,
        2530,
        2964
      ],
      "sample_values": [
        509,
        320,
        253,
        217,
        137,
        104,
        90,
        82,
        79,
        65,
        60,
        52,
        47,
        42,
        39,
        35,
        30,
        25,
        19,
        14,
        12,
        11,
        10,
        9,
        7,
        6,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Ignavigranum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Helcococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermacoccaceae;Kytococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Fastidiosipila",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae;Cloacibacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae"
      ]
    },
    {
      "id": "975",
      "otu_ids": [
        1795,
        922,
        944,
        2419,
        2539,
        909,
        2859,
        963,
        2651,
        1167,
        482,
        2011,
        2722,
        2461,
        1839,
        2782,
        2275,
        1200,
        1335,
        2318,
        1728,
        2396,
        1724,
        1950,
        2985,
        2964,
        2949,
        1189,
        2579,
        1602,
        2308,
        2551,
        1714,
        3450
      ],
      "sample_values": [
        300,
        78,
        71,
        38,
        36,
        22,
        21,
        16,
        12,
        11,
        10,
        10,
        9,
        9,
        7,
        6,
        5,
        5,
        5,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Fastidiosipila",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter"
      ]
    },
    {
      "id": "978",
      "otu_ids": [
        2859,
        1167,
        2011,
        482,
        1839,
        1335,
        1189,
        2782,
        2985,
        2275,
        1314,
        1950,
        2318,
        1188,
        1200,
        1333,
        2964,
        2396,
        1291,
        2058,
        2908,
        1985,
        1162,
        2722,
        2750,
        854,
        2273,
        2994,
        122,
        2496,
        3450,
        1294,
        2450,
        1213,
        391,
        830,
        847,
        2804,
        2793,
        874,
        1059,
        1960,
        1478,
        2133,
        2135,
        327,
        2992,
        2968,
        434,
        1883,
        1474,
        2837,
        242,
        2795,
        1334,
        1305,
        2755,
        2044,
        1139,
        2639,
        2580,
        2537,
        1180,
        1838,
        1186,
        1191,
        2310,
        2107,
        1230,
        2239,
        2187,
        1805
      ],
      "sample_values": [
        273,
        202,
        201,
        180,
        124,
        80,
        74,
        73,
        59,
        58,
        43,
        26,
        23,
        23,
        17,
        16,
        12,
        11,
        8,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Arcanobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Actinobacteria;Actinobacteria;Coriobacteriales;Coriobacteriaceae",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Carnobacteriaceae",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales"
      ]
    },
    {
      "id": "1233",
      "otu_ids": [922, 2419, 2859, 2722, 482, 944, 963, 1167, 2651],
      "sample_values": [26, 13, 8, 7, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus"
      ]
    },
    {
      "id": "1234",
      "otu_ids": [
        2539,
        1167,
        482,
        2859,
        2722,
        854,
        1169,
        2782,
        1335,
        2396,
        296,
        3450,
        2754,
        2275,
        2419,
        1950,
        874,
        841,
        2318,
        944,
        781,
        2244,
        2630,
        2335,
        909,
        2985,
        3439
      ],
      "sample_values": [
        95,
        82,
        70,
        61,
        61,
        46,
        44,
        28,
        22,
        21,
        17,
        16,
        14,
        12,
        11,
        9,
        9,
        9,
        8,
        7,
        6,
        5,
        3,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter"
      ]
    },
    {
      "id": "1235",
      "otu_ids": [
        2859,
        482,
        944,
        2011,
        2419,
        1167,
        922,
        1795,
        1839,
        2782,
        1335,
        1189,
        2722,
        2275,
        2985,
        2396,
        2318,
        2264,
        1950,
        1314,
        728,
        854,
        2308,
        1188,
        1162,
        943,
        3450,
        2539,
        2908,
        41,
        1200,
        2157,
        1169,
        963,
        3413,
        493,
        1291,
        1286,
        1059,
        2184,
        2964,
        2811,
        1805,
        2949,
        2335,
        1202,
        874,
        1728,
        833,
        2754,
        296,
        909,
        1164,
        930,
        2651,
        2571,
        242,
        1165,
        2190,
        1870,
        1840,
        1333,
        3541
      ],
      "sample_values": [
        125,
        121,
        113,
        110,
        102,
        62,
        58,
        52,
        48,
        30,
        29,
        29,
        26,
        18,
        16,
        15,
        10,
        10,
        10,
        10,
        9,
        9,
        9,
        9,
        7,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Coriobacteriales;Coriobacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Fastidiosipila",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter"
      ]
    },
    {
      "id": "1236",
      "otu_ids": [
        922,
        2539,
        2389,
        909,
        2419,
        943,
        841,
        1167,
        944,
        963,
        2461,
        2722,
        719,
        2859,
        818,
        1870,
        2483,
        606,
        2308,
        2590,
        854,
        737,
        1314,
        948,
        840,
        917,
        2404,
        2648,
        728,
        887,
        2190,
        2295,
        763,
        2666,
        579,
        2438,
        1232,
        1169,
        663,
        655,
        1164
      ],
      "sample_values": [
        352,
        219,
        164,
        122,
        101,
        74,
        54,
        54,
        40,
        36,
        35,
        30,
        20,
        11,
        11,
        11,
        7,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Turicella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas"
      ]
    },
    {
      "id": "1237",
      "otu_ids": [
        1795,
        2396,
        2308,
        2722,
        2859,
        2419,
        944,
        2782,
        1870,
        922,
        2539,
        1600,
        1724,
        2318,
        1167,
        1728,
        1453,
        3643,
        41,
        3352,
        963,
        2666,
        728,
        2011,
        1882,
        2949,
        307,
        2443,
        830,
        945,
        1959,
        2627,
        3507,
        3459,
        976,
        970,
        2908,
        1768,
        2847,
        352,
        482,
        1784,
        1788,
        1977,
        2513,
        2461,
        2452,
        1565,
        854,
        2389,
        909,
        939,
        189,
        1208
      ],
      "sample_values": [
        528,
        305,
        183,
        98,
        65,
        64,
        28,
        17,
        16,
        13,
        12,
        10,
        9,
        8,
        8,
        6,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Ignavigranum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Fastidiosipila",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Intrasporangiaceae;Janibacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermacoccaceae;Dermacoccus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas"
      ]
    },
    {
      "id": "1238",
      "otu_ids": [
        3031,
        3459,
        1167,
        2859,
        2419,
        3450,
        2722,
        41,
        1314,
        2964,
        1286,
        3022,
        2985,
        1977,
        1159,
        1335,
        3027,
        2754
      ],
      "sample_values": [
        93,
        89,
        53,
        21,
        15,
        12,
        12,
        8,
        8,
        6,
        5,
        4,
        3,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus"
      ]
    },
    {
      "id": "1242",
      "otu_ids": [
        944,
        2419,
        1795,
        2722,
        2539,
        2859,
        482,
        2011,
        1167,
        1839,
        728,
        939,
        963,
        2651,
        922,
        1870,
        2275,
        2985,
        3450,
        1335,
        2782,
        888,
        2461,
        2389,
        2396,
        909,
        2964,
        3476,
        2704,
        1314,
        943,
        2318,
        919,
        1977,
        2244,
        1189,
        2404,
        930,
        854,
        2500,
        2558,
        1950,
        3643,
        1188,
        352,
        1453,
        811,
        1286,
        1200,
        2039,
        920,
        2908,
        3581,
        3541,
        555,
        830,
        2089,
        959,
        2820,
        2692,
        1600,
        1724,
        2532,
        41
      ],
      "sample_values": [
        338,
        178,
        145,
        142,
        67,
        59,
        57,
        46,
        35,
        27,
        26,
        26,
        25,
        22,
        20,
        16,
        14,
        14,
        12,
        12,
        11,
        10,
        10,
        8,
        8,
        7,
        7,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria"
      ]
    },
    {
      "id": "1243",
      "otu_ids": [
        1795,
        944,
        922,
        2419,
        2539,
        909,
        1453,
        2859,
        3476,
        2011,
        1361,
        963,
        1167,
        2943,
        2722,
        1189,
        2275,
        2318,
        2651,
        482,
        1950,
        1169,
        2782,
        3360,
        883,
        1870,
        2461,
        1335,
        1839,
        2551,
        3030,
        943,
        3184,
        728,
        352,
        1724,
        2389,
        3544,
        1014,
        977,
        3581,
        3537,
        3568,
        3450,
        1878,
        3352,
        1600,
        1352,
        1200,
        1065,
        841,
        3613
      ],
      "sample_values": [
        146,
        73,
        60,
        47,
        42,
        36,
        30,
        28,
        22,
        20,
        14,
        12,
        10,
        9,
        8,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae;Cloacibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Faecalibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Intrasporangiaceae;Ornithinimicrobium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Aerococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Rubrobacterales;Rubrobacteraceae;Rubrobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;SR1;SR1_genera_incertae_sedis"
      ]
    },
    {
      "id": "1246",
      "otu_ids": [
        1167,
        2859,
        2318,
        165,
        2419,
        909,
        482,
        1950,
        2782,
        2275,
        2571,
        41,
        2191,
        2539,
        874,
        2396,
        2722,
        2964,
        1795,
        2244,
        944,
        2184,
        1189,
        841,
        2413,
        3450,
        2461,
        781,
        2308,
        2908,
        2342,
        2481,
        1333,
        2528,
        352,
        2800,
        2508,
        1314,
        1952,
        325,
        1188,
        316,
        2949,
        1232,
        2651,
        2350,
        2235,
        2855,
        2024,
        907,
        2239,
        2499,
        2075,
        2548,
        2820,
        2793,
        2936,
        1984,
        2340,
        1672,
        2520,
        2273,
        1536,
        2806,
        2750,
        2593,
        2583,
        2827,
        675,
        327,
        751,
        2534,
        1049,
        2505,
        871,
        1218,
        1225,
        1244,
        1490,
        931,
        1929,
        2103,
        2137,
        2189,
        121,
        2485,
        840,
        2344,
        2393,
        1144,
        2441,
        2457,
        2467,
        2473,
        2483,
        786
      ],
      "sample_values": [
        231,
        193,
        155,
        105,
        105,
        94,
        90,
        86,
        81,
        74,
        68,
        50,
        45,
        45,
        34,
        33,
        29,
        28,
        24,
        23,
        20,
        16,
        16,
        16,
        15,
        14,
        14,
        14,
        14,
        11,
        9,
        8,
        6,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Fastidiosipila",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Pseudonocardiaceae;Actinomycetospora",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales"
      ]
    },
    {
      "id": "1253",
      "otu_ids": [
        922,
        1795,
        1167,
        2419,
        944,
        2859,
        3643,
        41,
        482,
        943,
        2539,
        352,
        885,
        1208,
        2011,
        1169,
        2722,
        2318,
        728,
        2782,
        854,
        830,
        1189,
        1386,
        1977,
        3184,
        307,
        2389,
        1870,
        3219,
        1950,
        1762,
        408,
        1839,
        2308,
        3541,
        3275,
        939,
        2461,
        2190,
        719,
        963,
        909,
        2985,
        1398,
        1286,
        440,
        1314,
        954,
        606,
        2396,
        2404,
        3450,
        2184,
        2571,
        2651,
        883,
        3124,
        1388,
        3368,
        3312,
        1453,
        84,
        3212,
        3134,
        973,
        3117,
        1898,
        2275,
        2803,
        1929,
        1094,
        2648,
        2590,
        2264,
        1335,
        165
      ],
      "sample_values": [
        104,
        70,
        54,
        48,
        47,
        45,
        39,
        36,
        23,
        21,
        21,
        20,
        18,
        18,
        16,
        16,
        13,
        13,
        13,
        12,
        12,
        11,
        10,
        9,
        9,
        8,
        8,
        8,
        8,
        7,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Phyllobacteriaceae;Mesorhizobium",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Brachybacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Caulobacter",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dietziaceae;Dietzia",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Carnobacteriaceae;Granulicatella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Bacteroidetes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria"
      ]
    },
    {
      "id": "1254",
      "otu_ids": [
        943,
        922,
        923,
        1795,
        3476,
        1347,
        989,
        2389,
        944,
        1386,
        990,
        982,
        1398,
        3134,
        2419,
        440,
        983,
        3184,
        1388,
        3383,
        659,
        3389,
        3322,
        3275,
        797,
        2539,
        558,
        1399,
        937,
        1107,
        399
      ],
      "sample_values": [
        174,
        61,
        30,
        21,
        18,
        17,
        14,
        10,
        9,
        8,
        7,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Methylophilales;Methylophilaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes",
        "Bacteria"
      ]
    },
    {
      "id": "1258",
      "otu_ids": [
        2859,
        944,
        922,
        2011,
        2539,
        1189,
        482,
        2419,
        1795,
        728,
        1839,
        1870,
        3340,
        2782,
        2389,
        1167,
        2308,
        963,
        1977,
        391,
        3184,
        440,
        3275,
        2461,
        943,
        2275,
        3134,
        2244,
        41,
        1398,
        874,
        909,
        1004,
        1387,
        1388,
        1059,
        1335,
        1399,
        1929,
        3643,
        2964,
        3581,
        2264,
        3450,
        1286,
        3232,
        2450,
        352,
        830,
        296,
        307,
        3221,
        2985,
        1360,
        854,
        142,
        2184,
        1906,
        939,
        1431,
        2404,
        2314,
        1314,
        1950,
        2768
      ],
      "sample_values": [
        46,
        35,
        32,
        30,
        29,
        29,
        28,
        25,
        23,
        23,
        22,
        19,
        19,
        18,
        17,
        15,
        15,
        12,
        12,
        9,
        9,
        8,
        8,
        8,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Alcaligenaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Coriobacteriales;Coriobacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodobacterales;Rhodobacteraceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae;Chryseobacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Leuconostocaceae;Leuconostoc",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Sphingobacteriaceae;Sphingobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus"
      ]
    },
    {
      "id": "1259",
      "otu_ids": [
        3541,
        1795,
        3476,
        944,
        3581,
        830,
        1167,
        482,
        975,
        3282,
        2419,
        1929,
        41,
        1453,
        1977,
        1014,
        3036,
        3221,
        3607,
        3550,
        3536,
        1414,
        2318,
        2859,
        3561,
        3368,
        922,
        3256,
        3251,
        3224,
        3609,
        1375,
        954,
        1200,
        3608,
        3603,
        312,
        1208,
        1239,
        723,
        1276,
        807,
        3398,
        2461,
        3364,
        1012,
        3264,
        985,
        3255,
        1908,
        973,
        307,
        3212,
        2033,
        1048
      ],
      "sample_values": [
        161,
        35,
        32,
        25,
        13,
        13,
        11,
        11,
        9,
        8,
        8,
        8,
        6,
        6,
        6,
        6,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Intrasporangiaceae;Arsenicicoccus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodobacterales;Rhodobacteraceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Stenotrophomonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Cytophagaceae;Spirosoma",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales;Rhodospirillaceae;Skermanella",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodobacterales;Rhodobacteraceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Stenotrophomonas",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Brachybacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Stenotrophomonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Pseudoxanthomonas",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Rhodocyclales;Rhodocyclaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Arthrobacter",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Erythrobacteraceae;Erythrobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Leuconostocaceae;Weissella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dietziaceae;Dietzia",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Pseudonocardiaceae"
      ]
    },
    {
      "id": "1260",
      "otu_ids": [
        1795,
        2419,
        2539,
        944,
        2651,
        1398,
        440,
        1386,
        909,
        3541,
        2859,
        3184,
        482,
        2461,
        3275,
        2011,
        1388,
        2908,
        2722,
        2077,
        3383,
        1929,
        3232,
        2190,
        41,
        922,
        3470,
        3450,
        1839,
        531,
        1167,
        1724,
        2308,
        3414,
        3360,
        142,
        3134,
        2318,
        2782,
        2178,
        1959,
        2985,
        3507,
        3476,
        3472,
        1696,
        1921,
        3368,
        1926,
        1453,
        216,
        3064,
        1399,
        833,
        1335,
        1389,
        963,
        66,
        2964,
        118,
        2181,
        2322,
        2394,
        1770,
        1189,
        3363,
        781,
        1768,
        3207,
        3205,
        2184,
        3088,
        1387
      ],
      "sample_values": [
        199,
        98,
        94,
        79,
        28,
        22,
        22,
        18,
        17,
        17,
        17,
        13,
        12,
        11,
        11,
        11,
        10,
        9,
        8,
        8,
        8,
        7,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Methylophilales;Methylophilaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria",
        "Bacteria;Proteobacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Clostridiaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Hyphomicrobiaceae;Hyphomicrobium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae"
      ]
    },
    {
      "id": "1264",
      "otu_ids": [
        2859,
        2178,
        41,
        482,
        728,
        2908,
        3275,
        2077,
        2722,
        1795,
        1398,
        2539,
        854,
        1977,
        1167,
        3134,
        1399,
        2419,
        3184,
        3352,
        3383,
        2396,
        3643,
        2782,
        440,
        1388,
        3064,
        1824,
        2184,
        944,
        781,
        830,
        2275,
        1314,
        3232,
        2985,
        1386,
        2120,
        2754,
        3368,
        3360,
        1169,
        883,
        1387,
        2335,
        3219,
        3450,
        982,
        1967,
        939,
        1018,
        3306,
        531,
        2318,
        3197,
        1926,
        1162,
        3180,
        3131,
        1969,
        1959,
        1208,
        1929,
        1200
      ],
      "sample_values": [
        42,
        31,
        30,
        29,
        27,
        27,
        23,
        23,
        20,
        18,
        15,
        14,
        13,
        11,
        9,
        9,
        9,
        8,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Proteobacteria;Betaproteobacteria;Methylophilales;Methylophilaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Proteobacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Phyllobacteriaceae;Mesorhizobium",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micromonosporaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bradyrhizobium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas"
      ]
    },
    {
      "id": "1265",
      "otu_ids": [
        482,
        2859,
        41,
        2908,
        2077,
        728,
        2722,
        3643,
        1167,
        2178,
        854,
        1795,
        2419,
        1208,
        2539,
        1824,
        2396,
        3184,
        781,
        2782,
        1959,
        944,
        2184,
        1398,
        3275,
        440,
        2985,
        1977,
        1314,
        2190,
        1388,
        830,
        874,
        3134,
        4,
        1169,
        833,
        1744,
        939,
        3476,
        1969,
        1162,
        3232,
        3352,
        883,
        2275,
        982,
        1510,
        841,
        3285,
        1193,
        2318,
        3581,
        3219,
        1386,
        1746,
        2754,
        1013,
        1399,
        3191,
        141,
        3580,
        3383,
        3582,
        3408,
        390,
        3189,
        1724,
        419,
        3064,
        510,
        2964,
        2950,
        531,
        2899,
        2873,
        963,
        2404,
        1119,
        1213,
        1870,
        1927
      ],
      "sample_values": [
        121,
        118,
        75,
        74,
        72,
        71,
        68,
        59,
        55,
        55,
        45,
        36,
        31,
        28,
        26,
        26,
        24,
        22,
        22,
        22,
        21,
        20,
        16,
        14,
        14,
        13,
        13,
        12,
        11,
        11,
        11,
        9,
        9,
        7,
        7,
        6,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Archaea;Euryarchaeota;Methanobacteria;Methanobacteriales;Methanobacteriaceae;Methanobrevibacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Firmicutes",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Phyllobacteriaceae;Mesorhizobium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Planococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Kocuria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Cellvibrio",
        "Bacteria;Proteobacteria;Betaproteobacteria;Methylophilales;Methylophilaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Sinobacteraceae;Nevskia",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria",
        "Bacteria;Proteobacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Ruminococcus",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Bacteroidales_incertae_sedis;Phocaeicola",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus"
      ]
    },
    {
      "id": "1273",
      "otu_ids": [
        728,
        2722,
        2859,
        2419,
        1167,
        1824,
        2539,
        944,
        2396,
        1795,
        939,
        1314,
        874,
        982,
        2782,
        883,
        2275,
        2318,
        2666,
        963,
        841,
        830,
        2651,
        2908,
        1870,
        950,
        2347,
        2502,
        1672,
        2576,
        2369,
        2855,
        658,
        2675,
        2672,
        2688,
        2650,
        2577,
        2729,
        2800,
        370,
        2355,
        2234,
        2203,
        1893,
        625,
        1818,
        1807,
        1485,
        1386,
        949,
        888,
        876,
        820,
        691,
        1885
      ],
      "sample_values": [
        235,
        224,
        215,
        97,
        96,
        84,
        81,
        59,
        52,
        35,
        21,
        17,
        16,
        12,
        11,
        10,
        9,
        9,
        7,
        6,
        6,
        6,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Carnobacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Carnobacteriaceae"
      ]
    },
    {
      "id": "1275",
      "otu_ids": [
        1167,
        1208,
        3643,
        1950,
        3660,
        352,
        2318,
        408,
        1977,
        1189,
        2859,
        781,
        854,
        3007,
        2264,
        1314,
        874,
        2722,
        3450,
        909,
        2184,
        482,
        2539,
        2419,
        314,
        1795,
        2782,
        165,
        2964,
        1193,
        2651,
        1259,
        161,
        180,
        1169,
        3636,
        3626,
        2985,
        944,
        2404,
        2396,
        190,
        1083,
        2167,
        2158,
        2038,
        2025,
        771,
        146,
        1256,
        833,
        1178,
        96
      ],
      "sample_values": [
        159,
        103,
        59,
        30,
        29,
        27,
        21,
        21,
        21,
        19,
        18,
        16,
        16,
        14,
        14,
        14,
        14,
        12,
        11,
        11,
        9,
        9,
        9,
        8,
        8,
        8,
        7,
        6,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Pyramidobacter",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Succiniclasticum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Bacteroidetes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria"
      ]
    },
    {
      "id": "1276",
      "otu_ids": [
        922,
        2419,
        2859,
        944,
        2722,
        2651,
        1795,
        3450,
        936,
        830,
        659,
        2539,
        943,
        3476,
        1388,
        1386,
        1189,
        3275,
        963,
        1398
      ],
      "sample_values": [
        87,
        49,
        28,
        26,
        21,
        15,
        14,
        8,
        7,
        5,
        4,
        4,
        4,
        3,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium"
      ]
    },
    {
      "id": "1277",
      "otu_ids": [944, 922, 1795, 2419, 2461, 2539, 3275, 728, 939, 2722, 3064],
      "sample_values": [29, 25, 25, 8, 8, 6, 5, 3, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria"
      ]
    },
    {
      "id": "1278",
      "otu_ids": [
        922,
        1795,
        2419,
        2539,
        2859,
        944,
        1398,
        2722,
        719,
        775,
        2318,
        134,
        2324,
        3184,
        2562,
        2557,
        1672,
        1724,
        323,
        943,
        932,
        763,
        718,
        659,
        3275
      ],
      "sample_values": [
        196,
        173,
        108,
        44,
        8,
        6,
        5,
        4,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium"
      ]
    },
    {
      "id": "1279",
      "otu_ids": [
        2651,
        2419,
        922,
        2539,
        2722,
        943,
        2571,
        2244,
        944,
        2461,
        1870,
        2191,
        3184,
        1795
      ],
      "sample_values": [18, 16, 14, 12, 11, 9, 9, 7, 6, 6, 5, 3, 3, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus"
      ]
    },
    {
      "id": "1280",
      "otu_ids": [
        944,
        922,
        1795,
        909,
        2419,
        1870,
        963,
        2539,
        2389,
        2266,
        2551,
        2571,
        2461,
        3134,
        1398,
        1386,
        1388,
        2500,
        3275,
        2530,
        2524,
        952,
        3232,
        930,
        1620,
        3184,
        3063,
        2601,
        785,
        2394,
        830,
        1859,
        1399,
        1387,
        968,
        920,
        3383
      ],
      "sample_values": [
        240,
        98,
        98,
        91,
        78,
        56,
        26,
        21,
        16,
        15,
        9,
        8,
        7,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Methylophilales;Methylophilaceae"
      ]
    },
    {
      "id": "1281",
      "otu_ids": [
        944,
        1795,
        945,
        1386,
        3184,
        3275,
        440,
        1724,
        1387,
        1399,
        1714
      ],
      "sample_values": [161, 135, 4, 4, 4, 4, 3, 3, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales"
      ]
    },
    {
      "id": "1282",
      "otu_ids": [
        1722,
        1024,
        728,
        2539,
        944,
        2308,
        939,
        943,
        2419,
        2389,
        1025,
        1795,
        1721,
        2318,
        2266,
        1870,
        2264,
        2219,
        2378,
        426,
        617,
        2244,
        606,
        1698,
        1581,
        963,
        833,
        762,
        709,
        2463,
        2544,
        2859,
        2932,
        3184
      ],
      "sample_values": [
        129,
        95,
        46,
        42,
        36,
        33,
        28,
        12,
        10,
        10,
        7,
        7,
        6,
        5,
        5,
        5,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Nocardiaceae;Rhodococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Nocardiaceae;Rhodococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptostreptococcaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae"
      ]
    },
    {
      "id": "1283",
      "otu_ids": [
        1167,
        3643,
        41,
        1169,
        1977,
        2859,
        854,
        352,
        830,
        1208,
        307,
        2011,
        408,
        2539,
        482,
        728,
        1314,
        3450,
        1189,
        2985,
        1286,
        454,
        2167,
        2908,
        1326,
        1094,
        296,
        833,
        3636,
        1921,
        165,
        258,
        440,
        2184,
        2266,
        1398,
        2722,
        944,
        3184,
        2997,
        1388,
        2964,
        2483,
        1164,
        1870,
        1114
      ],
      "sample_values": [
        109,
        106,
        61,
        42,
        32,
        31,
        28,
        19,
        16,
        16,
        15,
        15,
        11,
        11,
        10,
        10,
        9,
        8,
        7,
        7,
        7,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales"
      ]
    },
    {
      "id": "1284",
      "otu_ids": [
        3643,
        1167,
        854,
        41,
        352,
        1977,
        1169,
        830,
        2985,
        2859,
        1208,
        1286,
        1314,
        307,
        728,
        408,
        482,
        296,
        258,
        1141,
        1189,
        1197,
        2754,
        1251,
        2167,
        454,
        302,
        449,
        2539,
        2184,
        92,
        1870,
        121,
        841,
        1224,
        171,
        1123,
        490
      ],
      "sample_values": [
        111,
        64,
        39,
        39,
        28,
        26,
        24,
        23,
        15,
        14,
        13,
        11,
        10,
        9,
        9,
        7,
        7,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria",
        "Bacteria",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae",
        "Bacteria"
      ]
    },
    {
      "id": "1285",
      "otu_ids": [
        2389,
        922,
        2539,
        3476,
        943,
        2266,
        2419,
        2722,
        2461,
        2859,
        1795,
        719,
        818,
        2308,
        606,
        763,
        2565,
        2364,
        2076,
        1453,
        2621,
        2421,
        47,
        2317,
        2286,
        131,
        917,
        789,
        737,
        460,
        3492,
        2375,
        2090,
        1016,
        963,
        2557,
        2602,
        2648,
        659
      ],
      "sample_values": [
        249,
        219,
        197,
        72,
        65,
        60,
        48,
        35,
        20,
        17,
        11,
        10,
        9,
        8,
        7,
        5,
        5,
        5,
        5,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Rothia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales"
      ]
    },
    {
      "id": "1286",
      "otu_ids": [
        2859,
        2011,
        1326,
        2722,
        3450,
        2539,
        922,
        2419,
        2964,
        2782,
        833,
        2318,
        728,
        2058,
        874,
        854,
        830,
        2806,
        2396,
        2985,
        1985,
        963,
        2804,
        3427,
        2704,
        2688,
        2185,
        2752,
        2803,
        2736,
        944,
        2847,
        2858,
        2666,
        2404,
        3430,
        345
      ],
      "sample_values": [
        202,
        160,
        88,
        68,
        67,
        46,
        29,
        25,
        19,
        13,
        7,
        7,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales",
        "Bacteria"
      ]
    },
    {
      "id": "1287",
      "otu_ids": [3476],
      "sample_values": [6],
      "otu_labels": ["Bacteria;Proteobacteria;Gammaproteobacteria"]
    },
    {
      "id": "1288",
      "otu_ids": [
        2539,
        2264,
        2859,
        944,
        907,
        2419,
        2191,
        2651,
        482,
        1870,
        2275,
        2244,
        2782,
        874,
        352,
        165,
        2396,
        1167,
        830,
        2308,
        2178,
        2340,
        2318,
        2235,
        2461,
        1950,
        1795,
        2382,
        269,
        2438,
        594,
        2571,
        2413,
        728,
        2389,
        2502,
        2184,
        883,
        909,
        2110,
        2190,
        847,
        2908,
        2964,
        2722,
        2737,
        2754,
        41,
        2444,
        2416,
        2350,
        2266,
        145,
        2229,
        2167,
        1873,
        833,
        739,
        3643
      ],
      "sample_values": [
        83,
        78,
        41,
        34,
        28,
        24,
        21,
        19,
        17,
        17,
        17,
        13,
        12,
        10,
        10,
        9,
        7,
        6,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Arcanobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Gallicola",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella"
      ]
    },
    {
      "id": "1289",
      "otu_ids": [
        482,
        2908,
        41,
        3643,
        2077,
        2178,
        1167,
        2859,
        854,
        1959,
        1208,
        781,
        4,
        2184,
        1314,
        2190,
        2985,
        1977,
        1169,
        3625,
        2754,
        3450,
        2910,
        11,
        122,
        170,
        1989,
        2773,
        2150,
        228,
        490,
        1200,
        2782,
        830,
        833,
        2912,
        2914,
        2871,
        491,
        2917,
        121,
        46,
        2929,
        2927,
        2919,
        2898,
        493,
        2539,
        1202,
        1084,
        1119,
        1180,
        1188,
        1189,
        1193,
        171,
        2257,
        1996,
        2067,
        2068,
        133,
        2120,
        2143,
        2127
      ],
      "sample_values": [
        104,
        82,
        77,
        63,
        61,
        58,
        49,
        47,
        35,
        34,
        32,
        28,
        27,
        18,
        17,
        16,
        16,
        10,
        9,
        8,
        7,
        7,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Archaea;Euryarchaeota;Methanobacteria;Methanobacteriales;Methanobacteriaceae;Methanobrevibacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Bacteroidales_incertae_sedis;Phocaeicola",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales"
      ]
    },
    {
      "id": "1290",
      "otu_ids": [3476, 1013, 3555, 924, 1014, 943, 1795, 3184, 3278, 3595],
      "sample_values": [50, 16, 10, 5, 5, 4, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Kocuria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Enhydrobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingobium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae"
      ]
    },
    {
      "id": "1291",
      "otu_ids": [
        1167,
        3643,
        854,
        41,
        1169,
        1977,
        830,
        352,
        1208,
        2539,
        2859,
        408,
        1189,
        1286,
        307,
        2985,
        944,
        1094,
        2011,
        728,
        482,
        296,
        1314,
        454,
        2167,
        258,
        1795,
        3450,
        2184,
        2389,
        1244,
        3636,
        1197,
        1326,
        874,
        2419,
        1141,
        2883,
        922,
        2908,
        2964,
        2782,
        963,
        92,
        2722,
        368,
        2396,
        2244,
        2190,
        165,
        1839,
        1200,
        169
      ],
      "sample_values": [
        83,
        82,
        50,
        47,
        26,
        21,
        19,
        18,
        16,
        14,
        13,
        11,
        8,
        8,
        8,
        7,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Lachnospiraceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria"
      ]
    },
    {
      "id": "1292",
      "otu_ids": [
        1167,
        3643,
        41,
        2859,
        2539,
        1169,
        922,
        352,
        1208,
        854,
        1977,
        944,
        1795,
        2011,
        482,
        830,
        1189,
        728,
        1314,
        2722,
        2419,
        307,
        2985,
        408,
        1286,
        3450,
        943,
        2782,
        1839,
        2964,
        3636,
        1870,
        3370,
        874,
        258,
        2167,
        1232,
        2318,
        2389,
        92,
        2244,
        165,
        2461,
        2275,
        909,
        1988,
        2941,
        391,
        963,
        2651,
        2908,
        3336,
        3511,
        3590,
        1453,
        2571,
        2308,
        2184,
        1805,
        84,
        1335,
        1197,
        1123,
        1108,
        1094,
        833,
        368,
        180,
        3660
      ],
      "sample_values": [
        114,
        99,
        60,
        52,
        35,
        30,
        28,
        27,
        27,
        26,
        25,
        25,
        23,
        21,
        18,
        18,
        14,
        14,
        12,
        12,
        11,
        11,
        10,
        8,
        8,
        7,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Schlegelella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae;Pantoea",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae",
        "Bacteria;Bacteroidetes",
        "Bacteria;Bacteroidetes",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria",
        "Bacteria",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Pyramidobacter"
      ]
    },
    {
      "id": "1293",
      "otu_ids": [
        3643,
        1167,
        41,
        1169,
        2859,
        854,
        2539,
        352,
        1977,
        2011,
        728,
        830,
        307,
        1208,
        2419,
        944,
        1189,
        2985,
        1314,
        482,
        3450,
        922,
        1286,
        296,
        2722,
        2964,
        258,
        454,
        874,
        408,
        2191,
        1326,
        3636,
        2244,
        1870,
        1795,
        1197,
        2648,
        180,
        2883,
        84,
        1244,
        2782,
        2389,
        909,
        2571,
        2666,
        92,
        2461,
        502,
        2266,
        943,
        2184,
        2167,
        833,
        841,
        1876,
        121
      ],
      "sample_values": [
        128,
        101,
        89,
        39,
        39,
        36,
        35,
        31,
        27,
        27,
        23,
        21,
        20,
        18,
        18,
        17,
        14,
        13,
        13,
        11,
        11,
        10,
        9,
        9,
        8,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Lachnospiraceae",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Abiotrophia",
        "Bacteria"
      ]
    },
    {
      "id": "1294",
      "otu_ids": [
        728,
        2539,
        2011,
        1870,
        982,
        944,
        1167,
        2419,
        2859,
        922,
        1795,
        2264,
        2389,
        1882,
        2722,
        2461,
        909,
        2754,
        2777,
        2571,
        1189,
        2782,
        2244,
        939,
        1977,
        482,
        2502,
        2778,
        189,
        2949,
        1859,
        963,
        2438,
        2651,
        814,
        2184,
        2445,
        296,
        2308,
        391,
        2275,
        658,
        2579,
        595,
        451,
        792,
        2830,
        2621,
        2524,
        833,
        2565,
        919,
        1720,
        2404,
        1865,
        2364,
        2340,
        2295,
        2191
      ],
      "sample_values": [
        123,
        89,
        70,
        52,
        51,
        48,
        43,
        27,
        25,
        25,
        23,
        22,
        20,
        15,
        14,
        14,
        11,
        9,
        9,
        8,
        8,
        8,
        7,
        6,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Ignavigranum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Fastidiosipila",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI"
      ]
    },
    {
      "id": "1295",
      "otu_ids": [
        1795,
        2011,
        482,
        2859,
        1929,
        728,
        2722,
        1167,
        2539,
        1189,
        2782,
        2389,
        944,
        1724,
        909,
        1876,
        1870,
        3643,
        1193,
        1977,
        2964,
        3352,
        3476,
        1926,
        1927,
        1208,
        1200,
        922,
        982,
        3450,
        2280,
        1314,
        41,
        2908,
        3134,
        4,
        2754,
        1768,
        1458,
        1333,
        516,
        3660
      ],
      "sample_values": [
        282,
        80,
        32,
        20,
        18,
        16,
        16,
        14,
        14,
        12,
        11,
        11,
        10,
        9,
        9,
        8,
        7,
        7,
        6,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Abiotrophia",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Archaea;Euryarchaeota;Methanobacteria;Methanobacteriales;Methanobacteriaceae;Methanobrevibacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Cyanobacteria;Cyanobacteria;FamilyI;GpI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Pyramidobacter"
      ]
    },
    {
      "id": "1296",
      "otu_ids": [
        1795,
        2722,
        1927,
        1839,
        839,
        2396,
        2859,
        944,
        3030,
        1659,
        2450,
        1728,
        1822,
        1724,
        1807,
        2682,
        3029,
        3025,
        2782,
        1615,
        2714,
        2706,
        2704,
        2688,
        2639,
        874,
        1619,
        1646,
        3450,
        2679,
        2701,
        2666,
        2598,
        2723,
        1600,
        2293,
        1492
      ],
      "sample_values": [
        267,
        266,
        106,
        63,
        44,
        41,
        33,
        21,
        18,
        9,
        8,
        5,
        5,
        5,
        5,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes"
      ]
    },
    {
      "id": "1297",
      "otu_ids": [482, 1959, 1744, 1108, 1870, 1927, 1929, 3561, 3581],
      "sample_values": [9, 6, 3, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Bacteroidetes",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas"
      ]
    },
    {
      "id": "1298",
      "otu_ids": [
        482,
        2178,
        2908,
        1795,
        41,
        2077,
        2859,
        3643,
        922,
        1167,
        1208,
        1959,
        854,
        4,
        1314,
        1169,
        2184,
        2539,
        833,
        2782,
        1977,
        2190,
        781,
        2419,
        2264,
        2754,
        3476,
        2722,
        2389,
        2985,
        1162,
        944,
        830,
        1200,
        728,
        171,
        170,
        2964,
        1870,
        3450,
        2244
      ],
      "sample_values": [
        81,
        57,
        55,
        49,
        47,
        42,
        39,
        32,
        32,
        26,
        23,
        22,
        14,
        13,
        13,
        12,
        12,
        12,
        10,
        9,
        9,
        8,
        7,
        6,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Archaea;Euryarchaeota;Methanobacteria;Methanobacteriales;Methanobacteriaceae;Methanobrevibacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI"
      ]
    },
    {
      "id": "1308",
      "otu_ids": [
        909,
        1795,
        944,
        1335,
        1167,
        2722,
        3450,
        2011,
        2754,
        830,
        296,
        1189,
        2964,
        839,
        482,
        2539,
        1314,
        2933,
        2859,
        2396,
        2782,
        1870,
        2419,
        841,
        1700,
        2985,
        2666,
        391,
        854,
        2949,
        1600,
        3280
      ],
      "sample_values": [
        112,
        86,
        60,
        52,
        40,
        22,
        16,
        14,
        13,
        13,
        10,
        10,
        9,
        9,
        8,
        8,
        6,
        5,
        5,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptostreptococcaceae;Peptostreptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Fastidiosipila",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas"
      ]
    },
    {
      "id": "1309",
      "otu_ids": [
        1795,
        1744,
        1700,
        1746,
        3184,
        1692,
        1453,
        728,
        1929,
        1722,
        830,
        2859,
        486,
        1727,
        3581,
        1016,
        1695,
        1510,
        3541,
        1057,
        1050,
        784,
        3372,
        3396,
        3571,
        1724
      ],
      "sample_values": [
        53,
        35,
        17,
        15,
        14,
        12,
        11,
        8,
        7,
        7,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Planococcaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Rothia",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Bifidobacteriales;Bifidobacteriaceae;Gardnerella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Pseudonocardiaceae;Saccharopolyspora",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales"
      ]
    },
    {
      "id": "1310",
      "otu_ids": [
        2011,
        482,
        728,
        2539,
        2859,
        944,
        1167,
        2908,
        1795,
        1870,
        2722,
        2754,
        2419,
        3450,
        854,
        41,
        982,
        1189,
        909,
        2077,
        3643,
        1977,
        2782,
        1208,
        1314,
        2178,
        2184,
        2985,
        2264,
        922,
        1959,
        833,
        1882,
        3476,
        841,
        2396,
        2651,
        1200,
        1188,
        2964,
        2461,
        2280,
        2275,
        2190,
        2157,
        1929,
        4
      ],
      "sample_values": [
        66,
        39,
        38,
        34,
        23,
        23,
        22,
        17,
        15,
        14,
        12,
        11,
        10,
        10,
        10,
        10,
        9,
        8,
        8,
        8,
        7,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Ignavigranum",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Archaea;Euryarchaeota;Methanobacteria;Methanobacteriales;Methanobacteriaceae;Methanobrevibacter"
      ]
    },
    {
      "id": "1374",
      "otu_ids": [
        1795,
        728,
        2539,
        944,
        2722,
        2859,
        1744,
        2754,
        2419,
        2782,
        841,
        939,
        3352,
        874,
        1724,
        2544,
        1600,
        2011,
        963,
        625,
        896,
        830,
        3541,
        2908,
        3184,
        482,
        2666,
        2579,
        2404,
        1453,
        1398,
        888,
        811,
        703,
        3581
      ],
      "sample_values": [
        276,
        269,
        174,
        92,
        56,
        50,
        38,
        29,
        24,
        18,
        13,
        9,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas"
      ]
    },
    {
      "id": "1415",
      "otu_ids": [
        1795,
        922,
        943,
        1453,
        1724,
        1387,
        3361,
        3312,
        3541,
        1361,
        1682,
        1904,
        2985,
        3507,
        3472,
        3306,
        531,
        1929,
        1744,
        1701,
        1525,
        986,
        1728
      ],
      "sample_values": [
        473,
        69,
        9,
        6,
        6,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae;Cloacibacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Lactobacillaceae;Lactobacillus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales"
      ]
    },
    {
      "id": "1439",
      "otu_ids": [
        944,
        1795,
        3372,
        3349,
        3581,
        1453,
        3184,
        10,
        1700,
        2419,
        1744,
        3064,
        1929,
        3134,
        3350,
        3352,
        1387,
        922,
        1600,
        1824,
        839,
        2461,
        1056,
        3381,
        1452,
        3300,
        3221,
        1057,
        1355,
        1921
      ],
      "sample_values": [
        88,
        71,
        57,
        54,
        13,
        11,
        10,
        10,
        9,
        9,
        8,
        7,
        6,
        6,
        6,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Cupriavidus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Proteobacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Cupriavidus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Bifidobacteriales;Bifidobacteriaceae;Bifidobacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Naxibacter",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodobacterales;Rhodobacteraceae",
        "Bacteria;Actinobacteria;Actinobacteria;Bifidobacteriales;Bifidobacteriaceae;Gardnerella",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus"
      ]
    },
    {
      "id": "1441",
      "otu_ids": [
        2011,
        1167,
        482,
        1314,
        909,
        3450,
        2859,
        1189,
        1200,
        2985,
        2539,
        2964,
        1114,
        2419,
        1193,
        1188,
        3643,
        1333,
        2722,
        2782,
        1977,
        1208,
        2908,
        1202,
        1985,
        2280,
        2396,
        2754,
        854,
        830,
        2157,
        1961,
        41,
        3660,
        1207,
        582,
        2358,
        2058,
        2273,
        2167,
        3454,
        3344,
        345,
        352,
        944,
        1164,
        2275,
        2185,
        2340,
        1795,
        2030,
        1981,
        59,
        2184,
        2804,
        171,
        180,
        3439,
        1186,
        3002,
        2994,
        320,
        408,
        2856,
        1998,
        1173,
        1176,
        2750,
        1083,
        1160,
        1162,
        2032,
        1224,
        2318,
        2308,
        1165,
        2088,
        2107,
        1244
      ],
      "sample_values": [
        401,
        132,
        116,
        96,
        74,
        52,
        51,
        40,
        39,
        26,
        20,
        18,
        12,
        11,
        11,
        11,
        11,
        10,
        10,
        10,
        9,
        9,
        8,
        8,
        8,
        7,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Pyramidobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Alcaligenaceae;Sutterella",
        "Bacteria",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas"
      ]
    },
    {
      "id": "1443",
      "otu_ids": [
        922,
        2419,
        1870,
        943,
        2539,
        883,
        2389,
        728,
        944,
        2461,
        2859,
        1795,
        2308,
        719,
        909,
        2558,
        482,
        3581,
        2571,
        818,
        2782,
        1882,
        2394,
        2314,
        3184,
        3134,
        2551,
        1387,
        2908,
        3285,
        1928,
        3064,
        3306,
        737,
        606,
        1453,
        2524,
        1929,
        3396,
        3287,
        3511,
        3232,
        1463,
        1013,
        3541,
        530,
        2648,
        963,
        2307,
        2602,
        1876,
        725,
        2500,
        907,
        2219,
        924,
        2547
      ],
      "sample_values": [
        184,
        152,
        128,
        113,
        78,
        78,
        77,
        70,
        51,
        42,
        19,
        17,
        15,
        12,
        10,
        9,
        9,
        7,
        7,
        7,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Ignavigranum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae;Pantoea",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales",
        "Bacteria;Deinococcus-Thermus;Deinococci;Deinococcales;Deinococcaceae;Deinococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Kocuria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Abiotrophia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus"
      ]
    },
    {
      "id": "1486",
      "otu_ids": [
        3218,
        3156,
        3160,
        728,
        2539,
        3211,
        41,
        944,
        3142,
        3172,
        3219,
        1208,
        1795,
        3158,
        3167
      ],
      "sample_values": [851, 18, 8, 7, 6, 5, 4, 3, 3, 3, 3, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Phyllobacteriaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Phyllobacteriaceae;Mesorhizobium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales"
      ]
    },
    {
      "id": "1487",
      "otu_ids": [
        3211,
        3219,
        3541,
        992,
        3134,
        3214,
        1013,
        1014,
        3036,
        3336,
        3368,
        3521,
        3529
      ],
      "sample_values": [105, 38, 5, 4, 4, 3, 2, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Phyllobacteriaceae;Mesorhizobium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Kocuria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae"
      ]
    },
    {
      "id": "1489",
      "otu_ids": [922, 3480, 3663, 763, 830, 889, 3039, 3204, 3609],
      "sample_values": [198, 4, 3, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Verrucomicrobia;Spartobacteria;Spartobacteria_genera_incertae_sedis",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Hyphomicrobiaceae;Devosia",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Stenotrophomonas"
      ]
    },
    {
      "id": "1490",
      "otu_ids": [
        1167,
        41,
        2539,
        728,
        1870,
        2419,
        3660,
        2722,
        944,
        296,
        2859,
        1208,
        2389,
        1200,
        922,
        1189,
        96,
        2244,
        1188,
        2964,
        2011,
        830,
        2754,
        3450,
        1260,
        1314,
        1213,
        1977,
        3007,
        2782,
        2985,
        2571,
        2955,
        1162,
        2461,
        909,
        1202,
        3614,
        1795,
        2908,
        1094,
        1232,
        2962,
        3643,
        314,
        2651,
        226,
        1230,
        1225,
        1166,
        1164,
        1145,
        1141,
        1263
      ],
      "sample_values": [
        288,
        68,
        56,
        50,
        44,
        36,
        31,
        29,
        26,
        21,
        20,
        20,
        20,
        19,
        19,
        17,
        17,
        16,
        16,
        15,
        15,
        14,
        11,
        11,
        10,
        10,
        8,
        8,
        8,
        7,
        7,
        6,
        6,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Pyramidobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Succiniclasticum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Bacteroidetes",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas"
      ]
    },
    {
      "id": "1491",
      "otu_ids": [
        1167,
        3450,
        909,
        2859,
        2419,
        391,
        2539,
        2722,
        1189,
        2933,
        1314,
        1159,
        1795,
        1335,
        944,
        2983,
        2571,
        2985,
        2935,
        922,
        2461,
        2308,
        3439,
        3426,
        2883,
        3427,
        2562,
        2855,
        2816,
        2764,
        2651,
        2445,
        1305,
        1298,
        948,
        3454
      ],
      "sample_values": [
        320,
        198,
        162,
        109,
        54,
        52,
        41,
        39,
        31,
        17,
        13,
        10,
        10,
        8,
        8,
        7,
        7,
        5,
        5,
        5,
        4,
        4,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptostreptococcaceae;Peptostreptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptostreptococcaceae;Peptostreptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Lachnospiraceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Turicella",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter"
      ]
    },
    {
      "id": "1494",
      "otu_ids": [
        922,
        1795,
        943,
        924,
        3541,
        3306,
        3368,
        2308,
        719,
        3581,
        3312,
        3360,
        3184,
        3196,
        659,
        3064,
        1724,
        737,
        3050
      ],
      "sample_values": [
        233,
        56,
        24,
        18,
        8,
        8,
        7,
        6,
        5,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bosea",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Streptobacillus"
      ]
    },
    {
      "id": "1495",
      "otu_ids": [],
      "sample_values": [],
      "otu_labels": []
    },
    {
      "id": "1497",
      "otu_ids": [
        482,
        2011,
        2859,
        3459,
        1167,
        1169,
        1950,
        2782,
        3450,
        1314,
        41,
        2483,
        1189,
        2318,
        1335,
        2023,
        1208,
        2754,
        2275,
        2264,
        2908,
        296,
        3660,
        2167,
        1200,
        2396,
        1977,
        1333,
        165,
        2190,
        2184,
        1162,
        830,
        944,
        314,
        1298,
        2964,
        2160,
        854,
        242,
        3009,
        1346,
        2244,
        2058,
        728,
        2820,
        327,
        943,
        3007,
        1094,
        2873,
        1197,
        922,
        1214,
        1256,
        1273,
        2362,
        2321,
        1279,
        510,
        2225,
        2208,
        391,
        2539
      ],
      "sample_values": [
        113,
        108,
        103,
        85,
        81,
        71,
        63,
        61,
        51,
        51,
        44,
        42,
        32,
        32,
        28,
        27,
        25,
        23,
        22,
        21,
        18,
        17,
        16,
        15,
        14,
        14,
        14,
        12,
        11,
        11,
        11,
        10,
        8,
        8,
        7,
        7,
        7,
        6,
        5,
        5,
        5,
        5,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Pyramidobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Succiniclasticum",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Succiniclasticum",
        "Bacteria;Bacteroidetes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus"
      ]
    },
    {
      "id": "1499",
      "otu_ids": [2859, 909, 922, 2266, 1795, 2419, 989, 963, 944, 943],
      "sample_values": [19, 15, 15, 11, 8, 8, 7, 4, 3, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium"
      ]
    },
    {
      "id": "1500",
      "otu_ids": [
        1795,
        1724,
        944,
        1600,
        1728,
        943,
        1788,
        3184,
        1714,
        1784,
        1685,
        1535,
        1387,
        922,
        1760,
        1783,
        1767,
        440,
        1754,
        830,
        1682,
        1610,
        1580,
        1525,
        3352
      ],
      "sample_values": [
        805,
        14,
        12,
        6,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia"
      ]
    },
    {
      "id": "1501",
      "otu_ids": [
        922,
        943,
        2389,
        2419,
        963,
        2266,
        2539,
        2308,
        606,
        659,
        2461,
        917,
        2571,
        3285,
        737,
        719,
        1870,
        560,
        889,
        818,
        715,
        2601,
        556
      ],
      "sample_values": [
        391,
        93,
        28,
        14,
        10,
        9,
        9,
        6,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales"
      ]
    },
    {
      "id": "1502",
      "otu_ids": [922, 1795, 2419, 943, 2389, 2461, 763, 2651, 889, 1453, 2539],
      "sample_values": [107, 14, 10, 6, 5, 5, 3, 3, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus"
      ]
    },
    {
      "id": "1503",
      "otu_ids": [
        2011,
        482,
        41,
        2539,
        1167,
        2859,
        1795,
        2077,
        3643,
        728,
        2178,
        854,
        2908,
        2722,
        3450,
        1870,
        1208,
        2419,
        2985,
        944,
        3476,
        1314,
        1189,
        1959,
        2264,
        1200,
        909,
        1977,
        2782,
        781,
        2184,
        833,
        922,
        2754,
        352,
        2190,
        2396,
        2389,
        4,
        982,
        1202,
        391,
        1169,
        2964,
        2651,
        2244,
        1114,
        963,
        939,
        3541,
        874,
        2571,
        242,
        2461,
        314,
        2275,
        2157,
        1987,
        1985,
        2280,
        2318,
        170,
        1969,
        830,
        92,
        408,
        165,
        2862,
        907,
        883,
        180,
        2688,
        2666,
        1728,
        841,
        307,
        1882
      ],
      "sample_values": [
        142,
        140,
        66,
        59,
        58,
        52,
        47,
        42,
        35,
        35,
        31,
        29,
        28,
        27,
        24,
        21,
        20,
        19,
        17,
        16,
        15,
        15,
        14,
        13,
        13,
        13,
        11,
        10,
        10,
        10,
        9,
        9,
        9,
        9,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Archaea;Euryarchaeota;Methanobacteria;Methanobacteriales;Methanobacteriaceae;Methanobrevibacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Ignavigranum"
      ]
    },
    {
      "id": "1504",
      "otu_ids": [
        922,
        1795,
        3306,
        3507,
        3585,
        912,
        889,
        1361,
        1387,
        1652,
        1921,
        1929,
        2419
      ],
      "sample_values": [121, 17, 4, 4, 4, 3, 2, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae;Cloacibacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus"
      ]
    },
    {
      "id": "1505",
      "otu_ids": [
        1795,
        2651,
        944,
        2419,
        2539,
        2461,
        3184,
        1425,
        1600,
        2571,
        1921,
        1410,
        2588,
        2510,
        3410,
        2318,
        142,
        1744,
        1902,
        531,
        1656,
        1535,
        1459,
        1019,
        1013,
        970,
        954,
        922,
        745,
        3476
      ],
      "sample_values": [
        255,
        155,
        82,
        49,
        8,
        7,
        5,
        4,
        4,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Sphingobacteriaceae;Mucilaginibacter",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Cytophagaceae;Hymenobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Lactobacillaceae",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes",
        "Bacteria;Cyanobacteria;Cyanobacteria;FamilyI;GpI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micromonosporaceae;Virgisporangium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Kocuria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermacoccaceae;Dermacoccus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Brachybacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria"
      ]
    },
    {
      "id": "1506",
      "otu_ids": [
        2539,
        909,
        1167,
        2722,
        1189,
        2859,
        2011,
        2964,
        3450,
        1188,
        2782,
        1213,
        2396,
        728,
        1162,
        2190,
        296,
        939,
        841,
        2318,
        1200,
        830,
        345,
        2191,
        1260,
        2404,
        2650,
        948,
        2855,
        1795
      ],
      "sample_values": [
        123,
        122,
        84,
        41,
        36,
        34,
        32,
        32,
        31,
        19,
        16,
        6,
        6,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Turicella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus"
      ]
    },
    {
      "id": "1507",
      "otu_ids": [
        922,
        1795,
        943,
        959,
        963,
        3221,
        2419,
        1014,
        1460,
        3541,
        3581,
        595,
        1929,
        2410,
        2461,
        1398,
        954,
        3184,
        3197,
        944,
        3499,
        606,
        3565,
        3574,
        232
      ],
      "sample_values": [
        67,
        43,
        25,
        12,
        10,
        9,
        9,
        9,
        7,
        6,
        6,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodobacterales;Rhodobacteraceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Deinococcus-Thermus;Deinococci;Deinococcales;Deinococcaceae;Deinococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Brachybacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bradyrhizobium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Alteromonadales;Idiomarinaceae;Idiomarina",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria"
      ]
    },
    {
      "id": "1508",
      "otu_ids": [944, 1926],
      "sample_values": [2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus"
      ]
    },
    {
      "id": "1510",
      "otu_ids": [
        1795,
        944,
        922,
        728,
        2722,
        3396,
        963,
        3134,
        939,
        841,
        3316,
        1724,
        763,
        2011,
        3472,
        3184,
        3534,
        2539,
        3523,
        3243,
        3163,
        556,
        2419,
        1929,
        715,
        1760,
        1580,
        1399,
        1014,
        930,
        796,
        1768
      ],
      "sample_values": [
        339,
        250,
        105,
        28,
        9,
        6,
        6,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae;Mannheimia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales;Acetobacteraceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae"
      ]
    },
    {
      "id": "1511",
      "otu_ids": [
        1167,
        2859,
        1314,
        3459,
        2754,
        3450,
        2985,
        2396,
        2722,
        2275,
        1795,
        922,
        2782,
        2539,
        944,
        833,
        728,
        2964,
        874,
        2908,
        909,
        3446,
        2838,
        2461,
        1244,
        1870,
        2816,
        2826,
        2855,
        1200,
        3443,
        3439,
        2340,
        2389,
        1232,
        1094,
        2419,
        830,
        1159
      ],
      "sample_values": [
        166,
        159,
        148,
        138,
        121,
        87,
        55,
        48,
        38,
        27,
        24,
        21,
        17,
        16,
        15,
        14,
        12,
        10,
        9,
        9,
        8,
        7,
        6,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas"
      ]
    },
    {
      "id": "1512",
      "otu_ids": [
        922,
        2308,
        2651,
        2419,
        944,
        2389,
        1795,
        943,
        2539,
        2722,
        1870,
        719,
        1929,
        3541,
        715,
        2401,
        1127,
        763,
        2301,
        2399,
        1387,
        2455,
        889,
        3134,
        3348,
        3459,
        3523,
        606
      ],
      "sample_values": [
        354,
        240,
        113,
        75,
        65,
        61,
        48,
        40,
        34,
        32,
        28,
        5,
        5,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Burkholderia",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales"
      ]
    },
    {
      "id": "1513",
      "otu_ids": [
        922,
        1795,
        944,
        963,
        1929,
        889,
        3368,
        1600,
        3184,
        1774,
        3306,
        3549,
        3396,
        3064,
        531,
        1881,
        1801,
        763,
        1726,
        1349,
        943,
        912,
        3581
      ],
      "sample_values": [
        389,
        204,
        29,
        21,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Jeotgalicoccus",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Proteobacteria",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Facklamia",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas"
      ]
    },
    {
      "id": "1514",
      "otu_ids": [
        1453,
        3396,
        1929,
        2247,
        2011,
        1926,
        3523,
        1335,
        1310,
        3581,
        3575,
        3530,
        3528,
        1014,
        1098,
        2539,
        3541,
        3534,
        3527,
        874,
        2744,
        2859,
        482,
        1015,
        1898,
        1795,
        3555,
        3520,
        1770,
        1316,
        2985,
        1314,
        1049,
        3568,
        909,
        728,
        911,
        944,
        1927,
        3209,
        3570,
        1387,
        1239,
        1925,
        3363,
        3184,
        3134,
        954,
        3049,
        3036,
        2964,
        2933,
        1167,
        2754,
        2318,
        1928,
        3064
      ],
      "sample_values": [
        39,
        37,
        26,
        18,
        14,
        14,
        12,
        11,
        8,
        8,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Bacteroidetes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae;Mannheimia",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Parvimonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Rothia",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Carnobacteriaceae;Granulicatella",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Enhydrobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Pseudonocardiaceae;Actinomycetospora",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Brachybacterium",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Streptobacillus",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptostreptococcaceae;Peptostreptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria"
      ]
    },
    {
      "id": "1515",
      "otu_ids": [
        922,
        1795,
        943,
        763,
        1724,
        672,
        927,
        944,
        556,
        737,
        889,
        1634,
        1665,
        1728,
        1768
      ],
      "sample_values": [430, 309, 12, 6, 5, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae"
      ]
    },
    {
      "id": "1516",
      "otu_ids": [
        922,
        1795,
        2722,
        2419,
        944,
        2539,
        2859,
        943,
        909,
        841,
        886,
        3251,
        2571,
        719,
        2461,
        2111,
        963,
        855,
        854,
        3352
      ],
      "sample_values": [
        38,
        27,
        27,
        26,
        25,
        20,
        20,
        7,
        6,
        5,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Cellulomonadaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales;Rhodospirillaceae;Skermanella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia"
      ]
    },
    {
      "id": "1517",
      "otu_ids": [
        1795,
        2539,
        2722,
        944,
        1167,
        2964,
        3450,
        2651,
        2419,
        909,
        839,
        830,
        2782,
        3568,
        1600,
        1728,
        3581,
        1724,
        939,
        841,
        2404,
        2710,
        1760,
        1239,
        3507,
        3575,
        1929
      ],
      "sample_values": [
        382,
        145,
        101,
        79,
        69,
        46,
        42,
        40,
        30,
        29,
        11,
        8,
        8,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus"
      ]
    },
    {
      "id": "1518",
      "otu_ids": [
        1167,
        41,
        1403,
        3450,
        2859,
        482,
        2539,
        3597,
        1795,
        2011,
        3262,
        1401,
        2782,
        2244,
        3603,
        296,
        165,
        2264,
        854,
        1745,
        1423,
        2275,
        944,
        2184,
        3491,
        907,
        1977,
        1189,
        2651,
        3599,
        1088,
        1200,
        3007,
        2908,
        1169,
        1314,
        2191,
        2138,
        314,
        3342,
        2964,
        1402,
        830,
        1420,
        1188,
        1208,
        1202,
        841,
        2318,
        3227,
        833,
        2119,
        1424,
        1373,
        3586,
        3494,
        1941,
        1213,
        3217,
        3341,
        508,
        3203,
        3176,
        3117,
        2985,
        2190,
        510
      ],
      "sample_values": [
        123,
        73,
        73,
        43,
        40,
        31,
        30,
        27,
        27,
        23,
        21,
        19,
        15,
        15,
        15,
        14,
        13,
        12,
        12,
        12,
        12,
        11,
        10,
        10,
        9,
        9,
        9,
        8,
        7,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Cyclobacteriaceae",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Luteimonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Erythrobacteraceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Cyclobacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Pseudoxanthomonas",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Planococcaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Sphingobacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Luteimonas",
        "Bacteria;Bacteroidetes",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Succiniclasticum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Alcaligenaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Cyclobacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Sphingobacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodobacterales;Rhodobacteraceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Sphingobacteriaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Phyllobacteriaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Alcaligenaceae",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Hyphomicrobiaceae;Devosia",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Aurantimonadaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria"
      ]
    },
    {
      "id": "1519",
      "otu_ids": [1795, 944, 2722, 1840, 1929, 1724, 1453],
      "sample_values": [78, 23, 7, 6, 4, 3, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta"
      ]
    },
    {
      "id": "1521",
      "otu_ids": [
        1795,
        944,
        2419,
        3485,
        1929,
        728,
        2722,
        922,
        1724,
        3389,
        1770,
        1453,
        1876,
        1600,
        3323,
        3134,
        3184,
        1353,
        3521,
        1926,
        1239,
        2859,
        1014,
        963,
        940,
        2318,
        626,
        3379,
        2544,
        3396,
        3609,
        1899,
        1728,
        1925,
        3393,
        3581,
        3555,
        3541,
        3527,
        808,
        3486,
        811,
        919,
        1015,
        930,
        1908,
        1064,
        1685,
        3146,
        1760,
        1801,
        1824,
        723,
        1898
      ],
      "sample_values": [
        553,
        418,
        136,
        69,
        68,
        40,
        27,
        13,
        12,
        11,
        11,
        10,
        9,
        7,
        6,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Abiotrophia",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Janthinobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Stenotrophomonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Lactobacillaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Enhydrobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Rothia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Leuconostocaceae;Weissella",
        "Bacteria;Actinobacteria;Actinobacteria;Rubrobacterales;Rubrobacteraceae;Rubrobacter",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Carnobacteriaceae;Granulicatella"
      ]
    },
    {
      "id": "1524",
      "otu_ids": [
        728,
        1167,
        2396,
        1977,
        2389,
        2219,
        2318,
        482,
        2244,
        2264,
        2011,
        2782,
        2247,
        2184,
        2266,
        2859,
        2722,
        939,
        2280,
        2138,
        922,
        830,
        2740,
        2630,
        2539,
        2754,
        41,
        165,
        2088,
        1189,
        944,
        907,
        883,
        2213
      ],
      "sample_values": [
        39,
        17,
        16,
        15,
        13,
        12,
        11,
        8,
        8,
        7,
        7,
        7,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Helcococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI"
      ]
    },
    {
      "id": "1526",
      "otu_ids": [3184, 728],
      "sample_values": [3, 2],
      "otu_labels": [
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales"
      ]
    },
    {
      "id": "1527",
      "otu_ids": [
        1929,
        1795,
        1770,
        3184,
        728,
        3541,
        3134,
        3211,
        922,
        3306,
        3064,
        3232,
        3286,
        2244,
        3575,
        2396,
        1745,
        2247,
        3396,
        3581,
        1387,
        3384,
        2318,
        3549,
        830,
        980,
        1926,
        3316,
        1824,
        1921,
        944,
        3276,
        1058,
        3415,
        2266,
        440,
        939,
        1744,
        3124,
        3333,
        3030,
        3312,
        3036,
        623,
        2782,
        2539,
        640,
        3410,
        3419,
        1845,
        3374,
        3368,
        3472,
        482,
        3568,
        531,
        1737,
        3282,
        1049,
        1726,
        1696,
        1839,
        1923,
        1927,
        1167,
        409,
        3258,
        2404,
        2949,
        3029,
        3089,
        3197,
        723,
        194
      ],
      "sample_values": [
        167,
        117,
        54,
        42,
        21,
        18,
        12,
        12,
        11,
        11,
        11,
        10,
        9,
        9,
        9,
        9,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Planococcaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Methylophilales;Methylophilaceae;Methylophilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Kineosporiaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria;Actinobacteria;Actinobacteria;Bifidobacteriales;Bifidobacteriaceae;Gardnerella",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales;Cystobacteraceae;Anaeromyxobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Caulobacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales;Polyangiaceae;Chondromyces",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Bacillaceae;Exiguobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Pseudonocardiaceae;Actinomycetospora",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Ruminococcaceae;Fastidiosipila",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bradyrhizobium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria"
      ]
    },
    {
      "id": "1530",
      "otu_ids": [
        2859,
        2722,
        3450,
        1314,
        1167,
        909,
        1189,
        2964,
        2985,
        2782,
        1188,
        296,
        1298,
        1795,
        2011,
        1200,
        1162,
        2855,
        1273,
        963,
        939,
        836,
        2419,
        1275,
        1202,
        1431,
        854,
        3426
      ],
      "sample_values": [
        125,
        107,
        95,
        73,
        67,
        44,
        38,
        23,
        18,
        15,
        11,
        8,
        8,
        7,
        7,
        7,
        6,
        6,
        4,
        4,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinobaculum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Sphingobacteriaceae;Sphingobacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales"
      ]
    },
    {
      "id": "1531",
      "otu_ids": [
        1795,
        830,
        922,
        3184,
        3312,
        944,
        3389,
        1600,
        2859,
        886,
        3306,
        1058,
        1724,
        3064,
        1768,
        1706,
        1405,
        1399,
        963,
        3316,
        3134,
        482,
        531,
        2396,
        2264,
        89,
        3509,
        3372,
        1043,
        3356,
        3371,
        3521,
        3523,
        3296,
        3197,
        3410,
        1921,
        3023,
        2651,
        2419,
        1926,
        310,
        1760,
        1744,
        1728,
        1525,
        939,
        911,
        728,
        3541
      ],
      "sample_values": [
        604,
        29,
        17,
        9,
        9,
        9,
        8,
        7,
        7,
        6,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Cellulomonadaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Bifidobacteriales;Bifidobacteriaceae;Gardnerella",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Cytophagaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae;Escherichia/Shigella",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Propionibacteriaceae;Propionibacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Variovorax",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bradyrhizobium",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter"
      ]
    },
    {
      "id": "1532",
      "otu_ids": [
        922,
        943,
        2308,
        1795,
        944,
        889,
        912,
        3352,
        3549,
        659,
        773,
        1728,
        3356
      ],
      "sample_values": [223, 81, 56, 55, 9, 6, 4, 3, 3, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis"
      ]
    },
    {
      "id": "1533",
      "otu_ids": [1795, 944, 922, 963, 909, 1728, 1600, 811, 1726, 3184],
      "sample_values": [335, 143, 87, 11, 5, 5, 4, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae"
      ]
    },
    {
      "id": "1534",
      "otu_ids": [
        1795,
        922,
        944,
        1929,
        3476,
        889,
        1600,
        3561,
        1728,
        1903,
        3541,
        1453,
        763,
        3064,
        659,
        3581,
        1724,
        1706,
        3284,
        3394,
        3396,
        3271,
        3184,
        3041,
        364,
        1926,
        1757,
        1726,
        1310,
        963,
        932,
        923,
        912,
        728,
        1930,
        1927,
        3063,
        3120,
        1770
      ],
      "sample_values": [
        685,
        621,
        111,
        22,
        12,
        11,
        11,
        9,
        8,
        8,
        7,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Lactobacillaceae;Lactobacillus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Conchiformibius",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Leptotrichia",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella"
      ]
    },
    {
      "id": "1535",
      "otu_ids": [
        1795,
        922,
        1724,
        1728,
        1760,
        1600,
        1665,
        2419,
        1525,
        1726,
        1565,
        1793,
        1706,
        1477,
        1794,
        1757,
        1766,
        1768,
        1714,
        1718,
        1709,
        1663,
        1651,
        1596,
        1580,
        1548,
        3184
      ],
      "sample_values": [
        1305,
        27,
        13,
        8,
        6,
        5,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae"
      ]
    },
    {
      "id": "1536",
      "otu_ids": [
        922,
        1795,
        2419,
        2461,
        1929,
        943,
        1600,
        1768,
        889,
        912,
        932,
        1602,
        1728,
        2308,
        3170
      ],
      "sample_values": [204, 182, 23, 13, 6, 5, 3, 3, 2, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales"
      ]
    },
    {
      "id": "1537",
      "otu_ids": [
        2419,
        2539,
        922,
        2389,
        944,
        2651,
        2722,
        1795,
        3352,
        3184,
        3360,
        595,
        2364,
        3134,
        3355
      ],
      "sample_values": [150, 112, 64, 63, 48, 44, 27, 20, 6, 4, 4, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Wautersia"
      ]
    },
    {
      "id": "1539",
      "otu_ids": [
        3643,
        1314,
        1167,
        1208,
        296,
        1335,
        3450,
        922,
        3031,
        728,
        2859,
        2722,
        2266,
        2964,
        854,
        1200,
        2985,
        1298,
        3404,
        3444,
        1882,
        2011,
        2782,
        939,
        2539,
        1977,
        830,
        1189,
        391,
        2983,
        2244,
        963,
        2190,
        3636,
        3628,
        841,
        1202,
        1188,
        2483,
        1291,
        1317,
        2016,
        3649
      ],
      "sample_values": [
        132,
        119,
        77,
        63,
        55,
        48,
        43,
        38,
        29,
        28,
        27,
        24,
        22,
        20,
        18,
        17,
        17,
        13,
        12,
        12,
        11,
        11,
        9,
        8,
        8,
        5,
        5,
        5,
        4,
        4,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Proteobacteria;Deltaproteobacteria",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae;Ignavigranum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella"
      ]
    },
    {
      "id": "1540",
      "otu_ids": [
        1014,
        1795,
        3120,
        970,
        944,
        3184,
        830,
        3064,
        1428,
        1929,
        1387,
        2722,
        1932,
        3541,
        3490,
        3134,
        1926,
        3381,
        3306,
        1770,
        3316,
        3509,
        3211,
        3416,
        3197,
        142,
        3583,
        2894,
        3372,
        3206,
        3561,
        3189,
        3643,
        1208,
        928,
        3093,
        687,
        3581,
        768,
        3523,
        3521,
        947,
        969,
        1025,
        3111,
        1386,
        3368,
        1399,
        1739,
        3282,
        3266,
        2100,
        2419,
        2880,
        51
      ],
      "sample_values": [
        43,
        39,
        32,
        32,
        23,
        18,
        18,
        14,
        11,
        8,
        7,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermacoccaceae;Dermacoccus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Sphingobacteriaceae;Sphingobacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Naxibacter",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae;Escherichia/Shigella",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales;Cystobacteraceae;Anaeromyxobacter",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bradyrhizobium",
        "Bacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Sinobacteraceae;Nevskia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Lachnospiraceae;Oribacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Hyphomicrobiaceae;Pedomicrobium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Turicella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermacoccaceae;Dermacoccus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Nocardiaceae;Rhodococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Bacillaceae;Tumebacillus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXIV;Blautia",
        "Bacteria"
      ]
    },
    {
      "id": "1541",
      "otu_ids": [],
      "sample_values": [],
      "otu_labels": []
    },
    {
      "id": "1542",
      "otu_ids": [],
      "sample_values": [],
      "otu_labels": []
    },
    {
      "id": "1543",
      "otu_ids": [
        1795,
        944,
        2419,
        1600,
        1724,
        3541,
        728,
        1706,
        2651,
        954,
        1682,
        1728,
        1768,
        1785,
        1801
      ],
      "sample_values": [428, 104, 22, 5, 4, 4, 3, 3, 3, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Brachybacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus"
      ]
    },
    {
      "id": "1544",
      "otu_ids": [1795, 939, 944, 2419, 728],
      "sample_values": [11, 5, 5, 3, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales"
      ]
    },
    {
      "id": "1545",
      "otu_ids": [
        1795,
        944,
        1840,
        2722,
        3507,
        3134,
        2396,
        2859,
        3352,
        1726,
        970,
        3541,
        3368,
        1728,
        830,
        1600,
        3184,
        3036,
        3120,
        3511,
        736,
        3029,
        2318,
        1706,
        1475,
        1454,
        1451,
        1314,
        909,
        885,
        3581
      ],
      "sample_values": [
        406,
        17,
        11,
        8,
        7,
        6,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermacoccaceae;Dermacoccus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae;Pantoea",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Brevibacteriaceae;Brevibacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas"
      ]
    },
    {
      "id": "1546",
      "otu_ids": [
        1795,
        944,
        1929,
        2722,
        1440,
        1724,
        3184,
        1706,
        1600,
        922,
        3064,
        1728,
        2396,
        1726,
        3550,
        2419,
        2651,
        728,
        3507,
        2011,
        1785,
        1926,
        1921,
        1911,
        2859,
        3200,
        482,
        207,
        1618,
        1596,
        1399,
        943,
        1770,
        3042,
        516,
        3389,
        3360,
        3306,
        531,
        3196,
        939,
        3150,
        3073,
        3043,
        989,
        3006,
        1669,
        1069,
        1108,
        1453,
        2318,
        1475,
        1565,
        1666,
        1902,
        1801,
        1788
      ],
      "sample_values": [
        981,
        41,
        21,
        17,
        11,
        11,
        7,
        7,
        7,
        6,
        6,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Cyanobacteria;Cyanobacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Lactococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Brucellaceae",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Leptotrichia",
        "Bacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bosea",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales",
        "Bacteria;Proteobacteria",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Leptotrichia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Selenomonas",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Actinobacteria;Actinobacteria;Solirubrobacterales;Conexibacteraceae;Conexibacter",
        "Bacteria;Bacteroidetes",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Lactobacillaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus"
      ]
    },
    {
      "id": "1547",
      "otu_ids": [
        970,
        1795,
        830,
        944,
        3389,
        963,
        736,
        1929,
        3184,
        943,
        922,
        989,
        1840,
        3296,
        1453,
        3211,
        1349,
        1377,
        1903,
        3472,
        3550,
        958,
        1043,
        1441,
        3476,
        939,
        3213,
        1448,
        3485,
        811,
        3378,
        3312,
        3282,
        3265,
        3197,
        1355,
        3134,
        3124,
        2961,
        2722,
        2419,
        1390,
        1910,
        1430,
        1898,
        732,
        319
      ],
      "sample_values": [
        146,
        65,
        39,
        34,
        29,
        19,
        16,
        14,
        12,
        10,
        8,
        8,
        7,
        6,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermacoccaceae;Dermacoccus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Lactobacillaceae;Lactobacillus",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Propionibacteriaceae;Propionibacterium",
        "Bacteria;Cyanobacteria;Cyanobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Herminiimonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bradyrhizobium",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Caulobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Lactococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Sphingobacteriaceae;Sphingobacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Carnobacteriaceae;Granulicatella",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria"
      ]
    },
    {
      "id": "1548",
      "otu_ids": [
        1795,
        3184,
        3316,
        1929,
        3197,
        3581,
        151,
        440,
        1021,
        1354,
        2722,
        3036,
        3209,
        3583
      ],
      "sample_values": [83, 7, 7, 4, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bradyrhizobium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Nocardiaceae;Gordonia",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Sinobacteraceae;Nevskia"
      ]
    },
    {
      "id": "1549",
      "otu_ids": [1795, 944, 922, 954, 1596, 3197],
      "sample_values": [183, 6, 4, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Brachybacterium",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bradyrhizobium"
      ]
    },
    {
      "id": "1550",
      "otu_ids": [1795, 944],
      "sample_values": [24, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium"
      ]
    },
    {
      "id": "1551",
      "otu_ids": [
        1795,
        944,
        3184,
        3581,
        943,
        3561,
        3485,
        1929,
        3134,
        1268,
        3568,
        3541,
        1727,
        3507,
        1409,
        963,
        3396,
        939,
        3110,
        922,
        1453,
        3064,
        3338,
        3381,
        3101,
        2651,
        3508,
        304,
        1362,
        1304,
        536,
        1387,
        3085,
        3316,
        3306,
        989,
        728,
        1921,
        3041,
        524,
        440,
        535,
        3544,
        3364,
        531,
        3562,
        830,
        3472,
        3569,
        1014,
        3379,
        3368,
        3330,
        3360,
        1444,
        2318,
        2397,
        1724,
        3030,
        319,
        3076,
        3164,
        3352,
        3197,
        3219,
        3275,
        3285,
        2182,
        1085,
        3593
      ],
      "sample_values": [
        70,
        23,
        21,
        19,
        19,
        11,
        9,
        9,
        8,
        7,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Cytophagaceae;Emticicia",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Neisseria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Proteobacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Alcaligenaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Naxibacter",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae",
        "Bacteria",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae;Flavobacterium",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Acidobacteria;Acidobacteria_Gp3;Gp3",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Leptotrichia",
        "Bacteria;Acidobacteria;Acidobacteria_Gp1;Gp1",
        "Bacteria",
        "Bacteria;Acidobacteria;Acidobacteria_Gp3;Gp3",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Janthinobacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Chlorophyta",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria",
        "Bacteria;Proteobacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiaceae;Ralstonia",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae;Bradyrhizobium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Phyllobacteriaceae;Mesorhizobium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Novosphingobium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingomonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Clostridiaceae",
        "Bacteria;Bacteroidetes",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae"
      ]
    },
    {
      "id": "1552",
      "otu_ids": [
        1795,
        944,
        830,
        939,
        922,
        1870,
        3604,
        3360,
        943,
        3184,
        1600,
        3541,
        3297,
        3292,
        3064,
        1724,
        1066,
        1728,
        1770,
        175,
        1714,
        3091,
        1038,
        963,
        894,
        3312,
        551,
        543,
        3581,
        3584,
        160
      ],
      "sample_values": [
        289,
        31,
        10,
        6,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Rhodanobacter",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Solirubrobacterales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Nocardioidaceae;Marmoricola",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Actinobacteria;Actinobacteria;Acidimicrobiales",
        "Bacteria;Actinobacteria;Actinobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Sinobacteraceae;Steroidobacter",
        "Bacteria"
      ]
    },
    {
      "id": "1553",
      "otu_ids": [
        2539,
        2419,
        874,
        728,
        841,
        944,
        2859,
        2404,
        3507,
        2264,
        1167,
        1795,
        1929,
        3495,
        2754,
        830,
        1314,
        1824,
        1200,
        2908,
        3306,
        3209,
        3389,
        3184,
        3041,
        151,
        2469,
        2985,
        2782,
        2722,
        2579,
        2561,
        2340,
        837,
        3541
      ],
      "sample_values": [
        449,
        162,
        51,
        33,
        26,
        25,
        24,
        13,
        9,
        8,
        8,
        7,
        6,
        6,
        5,
        5,
        5,
        4,
        4,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Enterobacteriales;Enterobacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Aeromonadales;Aeromonadaceae;Aeromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Methylobacteriaceae;Methylobacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Leptotrichia",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinobaculum",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter"
      ]
    },
    {
      "id": "1554",
      "otu_ids": [
        944,
        2651,
        909,
        2266,
        1795,
        2722,
        2419,
        922,
        2859,
        2539,
        830,
        841,
        2399
      ],
      "sample_values": [102, 64, 60, 45, 27, 24, 10, 5, 4, 3, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus"
      ]
    },
    {
      "id": "1555",
      "otu_ids": [
        1795,
        922,
        944,
        1902,
        1600,
        1706,
        1724,
        1728,
        140,
        889,
        1608,
        1669,
        1671,
        1768,
        1785,
        1929
      ],
      "sample_values": [567, 179, 41, 20, 8, 4, 4, 3, 2, 2, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Lactobacillaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus"
      ]
    },
    {
      "id": "1556",
      "otu_ids": [
        1795,
        922,
        944,
        943,
        2389,
        3566,
        963,
        1724,
        1600,
        1618,
        1706,
        719,
        3550,
        2539,
        2419,
        3581,
        1728,
        889,
        1768,
        1525,
        2651,
        3184,
        930,
        683
      ],
      "sample_values": [
        511,
        168,
        41,
        15,
        6,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Dermabacter",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales"
      ]
    },
    {
      "id": "1557",
      "otu_ids": [1795],
      "sample_values": [3],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus"
      ]
    },
    {
      "id": "1558",
      "otu_ids": [
        1795,
        482,
        1167,
        2859,
        2722,
        1950,
        2318,
        2396,
        2782,
        944,
        2275,
        1189,
        296,
        2335,
        830,
        2184,
        2011,
        2964,
        1977,
        2985,
        2908,
        1600,
        1728,
        1724,
        2855,
        1314,
        2244,
        1504,
        2630,
        2247,
        2443,
        2457,
        2826,
        2544,
        2542,
        2819,
        2706,
        2800,
        2750,
        2723,
        59,
        2239,
        1346,
        122,
        242,
        327,
        493,
        874,
        1191,
        1535,
        2191,
        1581,
        1618,
        1672,
        2035,
        67,
        2138,
        2109
      ],
      "sample_values": [
        449,
        171,
        128,
        95,
        92,
        89,
        83,
        77,
        58,
        40,
        33,
        23,
        15,
        14,
        8,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria",
        "Bacteria",
        "Bacteria",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Varibaculum",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales"
      ]
    },
    {
      "id": "1561",
      "otu_ids": [1795, 3134, 151, 531, 1386, 1399, 1929, 3120, 3306],
      "sample_values": [8, 5, 4, 4, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria;Proteobacteria;Betaproteobacteria"
      ]
    },
    {
      "id": "1562",
      "otu_ids": [944, 1795, 922, 930, 2419, 3476, 427, 1416, 1600, 1724, 3184],
      "sample_values": [156, 143, 53, 3, 3, 3, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Cytophagaceae;Spirosoma",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae"
      ]
    },
    {
      "id": "1563",
      "otu_ids": [
        3476,
        922,
        943,
        3082,
        1377,
        3492,
        1118,
        531,
        1387,
        142,
        238,
        2461,
        3134,
        3184,
        3306,
        3481
      ],
      "sample_values": [679, 50, 11, 9, 7, 7, 4, 3, 3, 2, 2, 2, 2, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Proteobacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Bacteroidaceae;Bacteroides",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria"
      ]
    },
    {
      "id": "1564",
      "otu_ids": [
        1795,
        3064,
        944,
        151,
        3184,
        531,
        1399,
        3409,
        3410,
        3134,
        1377,
        1929,
        3205,
        1728,
        1600,
        3472,
        1386,
        1724,
        1744,
        1760,
        3306,
        1351,
        3084,
        3056,
        3259,
        3308,
        3360,
        3368,
        3381,
        1927,
        830,
        440,
        578,
        457,
        3227,
        1453,
        976,
        3151,
        997,
        3097,
        1548,
        3077,
        1097,
        1361,
        1793,
        1387,
        1788
      ],
      "sample_values": [
        537,
        37,
        22,
        18,
        17,
        16,
        10,
        10,
        8,
        7,
        7,
        6,
        5,
        5,
        5,
        5,
        5,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Hyphomicrobiaceae;Hyphomicrobium",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae",
        "Bacteria;Proteobacteria",
        "Bacteria;Planctomycetes;Planctomycetacia;Planctomycetales;Planctomycetaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Burkholderiales_incertae_sedis;Aquabacterium",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Oxalobacteraceae;Naxibacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodobacterales;Rhodobacteraceae",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Intrasporangiaceae;Janibacter",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Microbacteriaceae",
        "Bacteria;Proteobacteria;Alphaproteobacteria",
        "Bacteria;Firmicutes",
        "Bacteria;Proteobacteria",
        "Bacteria;Bacteroidetes",
        "Bacteria;Bacteroidetes;Flavobacteria;Flavobacteriales;Flavobacteriaceae;Cloacibacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus"
      ]
    },
    {
      "id": "1572",
      "otu_ids": [
        1167,
        482,
        3643,
        1314,
        1208,
        3450,
        1795,
        728,
        854,
        1977,
        2859,
        1189,
        909,
        944,
        41,
        3007,
        2651,
        2754,
        1298,
        2264,
        830,
        1335,
        2184,
        2138,
        2811,
        3660,
        1206,
        1105,
        1959,
        2908,
        3659,
        408,
        493,
        3427,
        781,
        2985,
        2964,
        1090,
        939,
        293,
        2782,
        2722,
        1129,
        2539,
        2419,
        1232,
        1346
      ],
      "sample_values": [
        93,
        67,
        64,
        61,
        53,
        33,
        26,
        25,
        24,
        23,
        19,
        17,
        14,
        13,
        12,
        12,
        7,
        7,
        5,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Jonquetella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Mobiluncus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Succiniclasticum",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Pyramidobacter",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes",
        "Bacteria;Firmicutes;Clostridia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Synergistetes;Synergistia;Synergistales;Synergistaceae;Pyramidobacter",
        "Bacteria",
        "Bacteria",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Dialister",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Bacteroidetes",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella"
      ]
    },
    {
      "id": "1573",
      "otu_ids": [
        922,
        2419,
        1453,
        1744,
        531,
        1387,
        1795,
        3581,
        151,
        2651,
        3134
      ],
      "sample_values": [92, 5, 4, 4, 3, 3, 3, 3, 2, 2, 2],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Cyanobacteria;Cyanobacteria;Chloroplast;Streptophyta",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium"
      ]
    },
    {
      "id": "1574",
      "otu_ids": [
        482,
        909,
        2419,
        944,
        1795,
        1167,
        2859,
        922,
        2539,
        2964,
        2908,
        1314,
        2722,
        391,
        2275,
        1200,
        2651,
        2389,
        2461,
        151,
        1326,
        2318,
        296,
        2483,
        1387,
        2571,
        1386,
        2782,
        1189,
        1162,
        1399
      ],
      "sample_values": [
        29,
        18,
        16,
        15,
        14,
        14,
        14,
        13,
        13,
        9,
        7,
        5,
        5,
        5,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Peptococcaceae;Peptococcus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Peptoniphilus",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium"
      ]
    },
    {
      "id": "1576",
      "otu_ids": [
        1929,
        1770,
        1926,
        151,
        1016,
        3064,
        477,
        3184,
        225,
        1921,
        1824,
        531,
        1411,
        1839,
        1399,
        1924,
        1386,
        1286,
        3029,
        1108,
        3306,
        3541,
        3581
      ],
      "sample_values": [
        121,
        83,
        10,
        9,
        9,
        8,
        7,
        6,
        6,
        5,
        5,
        4,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Rothia",
        "Bacteria;Proteobacteria",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Cytophagaceae;Hymenobacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Bacteroidetes",
        "Bacteria;Proteobacteria;Betaproteobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Pseudomonadaceae;Pseudomonas"
      ]
    },
    {
      "id": "1577",
      "otu_ids": [
        922,
        1795,
        151,
        3184,
        1770,
        1929,
        3134,
        1399,
        3064,
        1108,
        3599,
        3514,
        3472,
        3410,
        1387,
        659,
        944,
        1744,
        531,
        3189,
        3340,
        3368,
        3405,
        1014,
        3541,
        1739,
        3607
      ],
      "sample_values": [
        152,
        130,
        10,
        9,
        6,
        6,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Gemella",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Proteobacteria",
        "Bacteria;Bacteroidetes",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Luteimonas",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Oceanospirillales;Alcanivoracaceae;Alcanivorax",
        "Bacteria;Proteobacteria;Gammaproteobacteria",
        "Bacteria;Proteobacteria;Deltaproteobacteria;Myxococcales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Paenibacillaceae;Paenibacillus",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Alcaligenaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales;Comamonadaceae;Pelomonas",
        "Bacteria;Proteobacteria;Deltaproteobacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Micrococcus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Bacillaceae;Tumebacillus",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Xanthomonadales;Xanthomonadaceae;Stenotrophomonas"
      ]
    },
    {
      "id": "1581",
      "otu_ids": [
        1795,
        3312,
        1399,
        3134,
        3288,
        3120,
        151,
        954,
        3184,
        531,
        3064,
        3541,
        1929,
        1600,
        3232,
        1921,
        3131,
        1785,
        1386,
        1052,
        3327,
        3035
      ],
      "sample_values": [
        176,
        57,
        10,
        10,
        9,
        8,
        6,
        6,
        6,
        5,
        5,
        5,
        4,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae;Sediminibacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Sphingomonadales;Sphingomonadaceae;Sphingopyxis",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Brevundimonas",
        "Bacteria",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Dermabacteraceae;Brachybacterium",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhizobiales;Bradyrhizobiaceae",
        "Bacteria;Acidobacteria;Acidobacteria_Gp2;Gp2",
        "Bacteria;Proteobacteria",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pseudomonadales;Moraxellaceae;Acinetobacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Rhodospirillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Alphaproteobacteria;Caulobacterales;Caulobacteraceae;Phenylobacterium",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Bacteroidetes;Sphingobacteria;Sphingobacteriales;Chitinophagaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Streptomycetaceae",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Fusobacteriaceae;Fusobacterium"
      ]
    },
    {
      "id": "1601",
      "otu_ids": [
        1929,
        3030,
        1795,
        894,
        1167,
        1926,
        3042,
        1930,
        944,
        2419,
        1924,
        1849,
        3395,
        3029,
        1917,
        1927,
        3450,
        1925,
        2651,
        922,
        1870,
        909,
        1293,
        2539,
        844,
        1921,
        2389,
        3012,
        2266,
        2722,
        1094,
        3044,
        1922,
        3019,
        3449,
        1646,
        3534,
        2964,
        3013,
        1304,
        1218,
        3312,
        1824,
        1833,
        1015,
        3016
      ],
      "sample_values": [
        166,
        129,
        97,
        94,
        73,
        51,
        32,
        32,
        25,
        22,
        16,
        15,
        15,
        14,
        13,
        13,
        12,
        11,
        10,
        10,
        9,
        9,
        9,
        9,
        7,
        7,
        6,
        6,
        6,
        5,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        2,
        2,
        2,
        2,
        2,
        2,
        2
      ],
      "otu_labels": [
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Bacilli;Bacillales;Staphylococcaceae;Staphylococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Leptotrichia",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Proteobacteria;Betaproteobacteria;Neisseriales;Neisseriaceae;Kingella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae;Corynebacterium",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Aerococcaceae",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Corynebacteriaceae",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Actinomycetaceae;Actinomyces",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Anaerococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;IncertaeSedisXI;Finegoldia",
        "Bacteria;Bacteroidetes",
        "Bacteria;Fusobacteria;Fusobacteria;Fusobacteriales;Leptotrichiaceae;Leptotrichia",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales;Streptococcaceae;Streptococcus",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Proteobacteria;Epsilonproteobacteria;Campylobacterales;Campylobacteraceae;Campylobacter",
        "Bacteria;Firmicutes;Bacilli",
        "Bacteria;Proteobacteria;Gammaproteobacteria;Pasteurellales;Pasteurellaceae;Mannheimia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Prevotellaceae;Prevotella",
        "Bacteria;Bacteroidetes;Bacteroidia;Bacteroidales;Porphyromonadaceae;Porphyromonas",
        "Bacteria;Proteobacteria;Betaproteobacteria;Burkholderiales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Firmicutes;Bacilli;Lactobacillales",
        "Bacteria;Actinobacteria;Actinobacteria;Actinomycetales;Micrococcaceae;Rothia",
        "Bacteria;Firmicutes;Clostridia;Clostridiales;Veillonellaceae;Veillonella"
      ]
    }
  ]
}
